//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.8.0 (NJsonSchema v11.0.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { ClientBase } from './client-base';import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class AlarmConfigClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    upsertAlarmConfiguration(projectId: string, alarmConfiguration: AlarmConfiguration, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/alarmconfigurations";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(alarmConfiguration);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsertAlarmConfiguration(_response);
        });
    }

    protected processUpsertAlarmConfiguration(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getAlarmConfigurations(projectId: string, cancelToken?: CancelToken): Promise<AlarmConfiguration[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/alarmconfigurations";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAlarmConfigurations(_response);
        });
    }

    protected processGetAlarmConfigurations(response: AxiosResponse): Promise<AlarmConfiguration[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlarmConfiguration.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AlarmConfiguration[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AlarmConfiguration[]>(null as any);
    }

    createAlarmConfiguration(projectId: string, newAlarmConfiguration: NewAlarmConfiguration, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/alarmconfigurations/new";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newAlarmConfiguration);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAlarmConfiguration(_response);
        });
    }

    protected processCreateAlarmConfiguration(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createAlarmConfiguration2(projectId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/alarmconfigurations/setup";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAlarmConfiguration2(_response);
        });
    }

    protected processCreateAlarmConfiguration2(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteAlarmConfiguration(projectId: string, id: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/alarmconfigurations/{id}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAlarmConfiguration(_response);
        });
    }

    protected processDeleteAlarmConfiguration(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    getAlarmConfiguration(projectId: string, id: string, cancelToken?: CancelToken): Promise<AlarmConfiguration> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/alarmconfigurations/{id}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAlarmConfiguration(_response);
        });
    }

    protected processGetAlarmConfiguration(response: AxiosResponse): Promise<AlarmConfiguration> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AlarmConfiguration.fromJS(resultData200);
            return Promise.resolve<AlarmConfiguration>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AlarmConfiguration>(null as any);
    }
}

export class AlarmClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    requestEvaluation(projectId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/request-evaluation";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestEvaluation(_response);
        });
    }

    protected processRequestEvaluation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    alarms(projectId: string, cancelToken?: CancelToken): Promise<Alarm[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/alarms";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAlarms(_response);
        });
    }

    protected processAlarms(response: AxiosResponse): Promise<Alarm[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Alarm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Alarm[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Alarm[]>(null as any);
    }

    deleteAlarms(projectId: string, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/alarms";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAlarms(_response);
        });
    }

    protected processDeleteAlarms(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    alarmsFiltered(projectId: string, alarmFilter: AlarmFilter, cancelToken?: CancelToken): Promise<Alarm[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/alarms";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(alarmFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAlarmsFiltered(_response);
        });
    }

    protected processAlarmsFiltered(response: AxiosResponse): Promise<Alarm[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Alarm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Alarm[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Alarm[]>(null as any);
    }

    alarmsCsv(projectId: string, alarmFilter: AlarmFilter, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/alarms/csv";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(alarmFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAlarmsCsv(_response);
        });
    }

    protected processAlarmsCsv(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    alarm(projectId: string, id: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/alarms/{id}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAlarm(_response);
        });
    }

    protected processAlarm(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    deleteAisAlarms(projectId: string, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/alarms/type/ais";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAisAlarms(_response);
        });
    }

    protected processDeleteAisAlarms(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    deleteDasAlarms(projectId: string, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/alarms/type/das";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteDasAlarms(_response);
        });
    }

    protected processDeleteDasAlarms(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    deleteDtsAlarms(projectId: string, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/alarms/type/dts";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteDtsAlarms(_response);
        });
    }

    protected processDeleteDtsAlarms(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    updateActivation(projectId: string, id: string, request: UpdateActivationRequest, cancelToken?: CancelToken): Promise<Alarm> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/alarms/{id}/activation-update";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateActivation(_response);
        });
    }

    protected processUpdateActivation(response: AxiosResponse): Promise<Alarm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Alarm.fromJS(resultData200);
            return Promise.resolve<Alarm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Alarm>(null as any);
    }

    bulkUpdateActivation(projectId: string, request: BulkUpdateActivationRequest, cancelToken?: CancelToken): Promise<BulkActivationResult> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/alarms/bulk-activation-update";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkUpdateActivation(_response);
        });
    }

    protected processBulkUpdateActivation(response: AxiosResponse): Promise<BulkActivationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BulkActivationResult.fromJS(resultData200);
            return Promise.resolve<BulkActivationResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BulkActivationResult>(null as any);
    }

    visitedAlarm(projectId: string, id: string, cancelToken?: CancelToken): Promise<Alarm> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/alarms/{id}/visisted";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVisitedAlarm(_response);
        });
    }

    protected processVisitedAlarm(response: AxiosResponse): Promise<Alarm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Alarm.fromJS(resultData200);
            return Promise.resolve<Alarm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Alarm>(null as any);
    }

    dtsForAlarm(projectId: string, id: string, cancelToken?: CancelToken): Promise<AlarmDTSChart> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/alarms/{id}/dts";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDtsForAlarm(_response);
        });
    }

    protected processDtsForAlarm(response: AxiosResponse): Promise<AlarmDTSChart> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AlarmDTSChart.fromJS(resultData200);
            return Promise.resolve<AlarmDTSChart>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AlarmDTSChart>(null as any);
    }

    dasForAlarm(projectId: string, id: string, cancelToken?: CancelToken): Promise<AlarmDASChart> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/alarms/{id}/das";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDasForAlarm(_response);
        });
    }

    protected processDasForAlarm(response: AxiosResponse): Promise<AlarmDASChart> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AlarmDASChart.fromJS(resultData200);
            return Promise.resolve<AlarmDASChart>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AlarmDASChart>(null as any);
    }

    doBForAlarm(projectId: string, id: string, cancelToken?: CancelToken): Promise<AlarmDoBChart> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/alarms/{id}/dob";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDoBForAlarm(_response);
        });
    }

    protected processDoBForAlarm(response: AxiosResponse): Promise<AlarmDoBChart> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AlarmDoBChart.fromJS(resultData200);
            return Promise.resolve<AlarmDoBChart>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AlarmDoBChart>(null as any);
    }
}

export class CableClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    cable(projectId: string, ts: Date | null | undefined, cancelToken?: CancelToken): Promise<MapCableDataPoint[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/cable?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (ts !== undefined && ts !== null)
            url_ += "ts=" + encodeURIComponent(ts ? "" + ts.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCable(_response);
        });
    }

    protected processCable(response: AxiosResponse): Promise<MapCableDataPoint[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MapCableDataPoint.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MapCableDataPoint[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MapCableDataPoint[]>(null as any);
    }

    cableInfo(projectId: string, cancelToken?: CancelToken): Promise<CableInfo> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/cableinfo";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCableInfo(_response);
        });
    }

    protected processCableInfo(response: AxiosResponse): Promise<CableInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CableInfo.fromJS(resultData200);
            return Promise.resolve<CableInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CableInfo>(null as any);
    }

    cableUpload(projectId: string, file: FileParameter | undefined, delimiter: string | undefined, mappingsSource: string[] | undefined, mappingsTarget: string[] | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/shape";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (delimiter === null || delimiter === undefined)
            throw new Error("The parameter 'delimiter' cannot be null.");
        else
            content_.append("delimiter", delimiter.toString());
        if (mappingsSource === null || mappingsSource === undefined)
            throw new Error("The parameter 'mappingsSource' cannot be null.");
        else
            mappingsSource.forEach(item_ => content_.append("mappingsSource", item_.toString()));
        if (mappingsTarget === null || mappingsTarget === undefined)
            throw new Error("The parameter 'mappingsTarget' cannot be null.");
        else
            mappingsTarget.forEach(item_ => content_.append("mappingsTarget", item_.toString()));

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCableUpload(_response);
        });
    }

    protected processCableUpload(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteCableShape(projectId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/shape";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCableShape(_response);
        });
    }

    protected processDeleteCableShape(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadCableShape(projectId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/shape/download";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadCableShape(_response);
        });
    }

    protected processDownloadCableShape(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getRequiredColumns( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/projects/shape";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRequiredColumns(_response);
        });
    }

    protected processGetRequiredColumns(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class ConfigurationClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getAuthConfig( cancelToken?: CancelToken): Promise<AuthConfiguration> {
        let url_ = this.baseUrl + "/api/authconfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuthConfig(_response);
        });
    }

    protected processGetAuthConfig(response: AxiosResponse): Promise<AuthConfiguration> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthConfiguration.fromJS(resultData200);
            return Promise.resolve<AuthConfiguration>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthConfiguration>(null as any);
    }
}

export class DasClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    dasChartForDate(projectId: string, filter: ChartFilter, cancelToken?: CancelToken): Promise<DASChart> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/das/chart";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDasChartForDate(_response);
        });
    }

    protected processDasChartForDate(response: AxiosResponse): Promise<DASChart> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DASChart.fromJS(resultData200);
            return Promise.resolve<DASChart>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DASChart>(null as any);
    }

    dasForDate(projectId: string, ts: Date | undefined, cancelToken?: CancelToken): Promise<DasValue[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/das?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (ts === null)
            throw new Error("The parameter 'ts' cannot be null.");
        else if (ts !== undefined)
            url_ += "ts=" + encodeURIComponent(ts ? "" + ts.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDasForDate(_response);
        });
    }

    protected processDasForDate(response: AxiosResponse): Promise<DasValue[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DasValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DasValue[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DasValue[]>(null as any);
    }
}

export class DatabaseClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    migrate( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/db/migrate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMigrate(_response);
        });
    }

    protected processMigrate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class DoBClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    dobChartForDate(projectId: string, filter: ChartFilter, cancelToken?: CancelToken): Promise<DoBChart> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/dob/chart";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDobChartForDate(_response);
        });
    }

    protected processDobChartForDate(response: AxiosResponse): Promise<DoBChart> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DoBChart.fromJS(resultData200);
            return Promise.resolve<DoBChart>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DoBChart>(null as any);
    }

    doBForDate(projectId: string, cancelToken?: CancelToken): Promise<DoBValue[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/dob";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDoBForDate(_response);
        });
    }

    protected processDoBForDate(response: AxiosResponse): Promise<DoBValue[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DoBValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DoBValue[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DoBValue[]>(null as any);
    }

    doBUpload(projectId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/dob";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDoBUpload(_response);
        });
    }

    protected processDoBUpload(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DocumentationClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    uploadFile(projectIds: string[] | undefined, file: FileParameter | undefined, parentFolder: string | undefined, subCategory: string | null | undefined, relations: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/documentation/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (projectIds === null || projectIds === undefined)
            throw new Error("The parameter 'projectIds' cannot be null.");
        else
            projectIds.forEach(item_ => content_.append("projectIds", item_.toString()));
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (parentFolder === null || parentFolder === undefined)
            throw new Error("The parameter 'parentFolder' cannot be null.");
        else
            content_.append("parentFolder", parentFolder.toString());
        if (subCategory !== null && subCategory !== undefined)
            content_.append("subCategory", subCategory.toString());
        if (relations === null || relations === undefined)
            throw new Error("The parameter 'relations' cannot be null.");
        else
            content_.append("relations", relations.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadFile(_response);
        });
    }

    protected processUploadFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadSurveyDocument(projectId: string | undefined, surveyId: string | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/documentation/survey/upload?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (surveyId === null)
            throw new Error("The parameter 'surveyId' cannot be null.");
        else if (surveyId !== undefined)
            url_ += "surveyId=" + encodeURIComponent("" + surveyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadSurveyDocument(_response);
        });
    }

    protected processUploadSurveyDocument(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadSpareDocumentList(projectIds: string[] | undefined, locationId: string | null | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/documentation/spareparts/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (projectIds === null || projectIds === undefined)
            throw new Error("The parameter 'projectIds' cannot be null.");
        else
            projectIds.forEach(item_ => content_.append("projectIds", item_.toString()));
        if (locationId !== null && locationId !== undefined)
            content_.append("locationId", locationId.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadSpareDocumentList(_response);
        });
    }

    protected processUploadSpareDocumentList(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadFile(projectId: string, fileId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/documentation/files/{fileId}/download";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadFile(_response);
        });
    }

    protected processDownloadFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteFile(projectId: string, fileId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/documentation/files/{fileId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFile(_response);
        });
    }

    protected processDeleteFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getFiles(request: FilesRequest, cancelToken?: CancelToken): Promise<File[]> {
        let url_ = this.baseUrl + "/api/projects/documentation/files";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFiles(_response);
        });
    }

    protected processGetFiles(response: AxiosResponse): Promise<File[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(File.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<File[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<File[]>(null as any);
    }

    getFolders(projectIds: string[] | undefined, cancelToken?: CancelToken): Promise<Folder[]> {
        let url_ = this.baseUrl + "/api/projects/documentation/folders?";
        if (projectIds === null)
            throw new Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFolders(_response);
        });
    }

    protected processGetFolders(response: AxiosResponse): Promise<Folder[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Folder.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Folder[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Folder[]>(null as any);
    }

    upsertFolder(folder: Folder, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/documentation/folders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(folder);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsertFolder(_response);
        });
    }

    protected processUpsertFolder(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteFolder(folderId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/documentation/folders/{folderId}";
        if (folderId === undefined || folderId === null)
            throw new Error("The parameter 'folderId' must be defined.");
        url_ = url_.replace("{folderId}", encodeURIComponent("" + folderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFolder(_response);
        });
    }

    protected processDeleteFolder(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getFoldersByProject( cancelToken?: CancelToken): Promise<ProjectFolder[]> {
        let url_ = this.baseUrl + "/api/projects/documentation/administration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFoldersByProject(_response);
        });
    }

    protected processGetFoldersByProject(response: AxiosResponse): Promise<ProjectFolder[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectFolder.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProjectFolder[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectFolder[]>(null as any);
    }

    getFolderByProject(projectId: string, cancelToken?: CancelToken): Promise<ProjectFolder[]> {
        let url_ = this.baseUrl + "/api/projects/documentation/administration/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFolderByProject(_response);
        });
    }

    protected processGetFolderByProject(response: AxiosResponse): Promise<ProjectFolder[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectFolder.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProjectFolder[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectFolder[]>(null as any);
    }
}

export class DtsClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    dtsForDate(projectId: string, ts: Date | undefined, cancelToken?: CancelToken): Promise<DtsValue[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/dts?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (ts === null)
            throw new Error("The parameter 'ts' cannot be null.");
        else if (ts !== undefined)
            url_ += "ts=" + encodeURIComponent(ts ? "" + ts.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDtsForDate(_response);
        });
    }

    protected processDtsForDate(response: AxiosResponse): Promise<DtsValue[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DtsValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DtsValue[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DtsValue[]>(null as any);
    }

    dtsChartForDate(projectId: string, filter: DTSChartFilter, cancelToken?: CancelToken): Promise<DTSChart> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/dts/chart";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDtsChartForDate(_response);
        });
    }

    protected processDtsChartForDate(response: AxiosResponse): Promise<DTSChart> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DTSChart.fromJS(resultData200);
            return Promise.resolve<DTSChart>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DTSChart>(null as any);
    }
}

export class HomeClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getCableOverview(projectId: string, ts: Date | null | undefined, cancelToken?: CancelToken): Promise<OverviewModel> {
        let url_ = this.baseUrl + "/api/project/{projectId}/overview?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (ts !== undefined && ts !== null)
            url_ += "ts=" + encodeURIComponent(ts ? "" + ts.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCableOverview(_response);
        });
    }

    protected processGetCableOverview(response: AxiosResponse): Promise<OverviewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OverviewModel.fromJS(resultData200);
            return Promise.resolve<OverviewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OverviewModel>(null as any);
    }
}

export class LocationClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    upsertLocation(location: Location, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/locations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(location);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsertLocation(_response);
        });
    }

    protected processUpsertLocation(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getLocations( cancelToken?: CancelToken): Promise<Location[]> {
        let url_ = this.baseUrl + "/api/locations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLocations(_response);
        });
    }

    protected processGetLocations(response: AxiosResponse): Promise<Location[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Location.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Location[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Location[]>(null as any);
    }

    getLocationsByOrg( cancelToken?: CancelToken): Promise<OrgLocations[]> {
        let url_ = this.baseUrl + "/api/locationsByOrg";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLocationsByOrg(_response);
        });
    }

    protected processGetLocationsByOrg(response: AxiosResponse): Promise<OrgLocations[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrgLocations.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OrgLocations[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrgLocations[]>(null as any);
    }

    getLocationsFromOrganization(id: string, cancelToken?: CancelToken): Promise<OrgLocations> {
        let url_ = this.baseUrl + "/api/organization/{id}/locations";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLocationsFromOrganization(_response);
        });
    }

    protected processGetLocationsFromOrganization(response: AxiosResponse): Promise<OrgLocations> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrgLocations.fromJS(resultData200);
            return Promise.resolve<OrgLocations>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrgLocations>(null as any);
    }

    getLocation(id: string, cancelToken?: CancelToken): Promise<Location> {
        let url_ = this.baseUrl + "/api/locations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLocation(_response);
        });
    }

    protected processGetLocation(response: AxiosResponse): Promise<Location> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Location.fromJS(resultData200);
            return Promise.resolve<Location>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Location>(null as any);
    }

    deleteLocation(id: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/locations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteLocation(_response);
        });
    }

    protected processDeleteLocation(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class OrganizationClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    createOrganization(item: NewAppOrganization, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/organizations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrganization(_response);
        });
    }

    protected processCreateOrganization(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateOrganization(item: AppOrganization, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/organizations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOrganization(_response);
        });
    }

    protected processUpdateOrganization(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getOrganizations( cancelToken?: CancelToken): Promise<AppOrganization[]> {
        let url_ = this.baseUrl + "/api/organizations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizations(_response);
        });
    }

    protected processGetOrganizations(response: AxiosResponse): Promise<AppOrganization[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppOrganization.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AppOrganization[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppOrganization[]>(null as any);
    }

    sendOrganisationAdminAssignmentMail(recipientAddress: string | undefined, organisationName: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/organizations/mail?";
        if (recipientAddress === null)
            throw new Error("The parameter 'recipientAddress' cannot be null.");
        else if (recipientAddress !== undefined)
            url_ += "recipientAddress=" + encodeURIComponent("" + recipientAddress) + "&";
        if (organisationName === null)
            throw new Error("The parameter 'organisationName' cannot be null.");
        else if (organisationName !== undefined)
            url_ += "organisationName=" + encodeURIComponent("" + organisationName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendOrganisationAdminAssignmentMail(_response);
        });
    }

    protected processSendOrganisationAdminAssignmentMail(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteOrganization(id: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/organizations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteOrganization(_response);
        });
    }

    protected processDeleteOrganization(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getOrganizationWithUsers(id: string, cancelToken?: CancelToken): Promise<AppOrganizationWithUsers> {
        let url_ = this.baseUrl + "/api/organizations/{id}/users";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizationWithUsers(_response);
        });
    }

    protected processGetOrganizationWithUsers(response: AxiosResponse): Promise<AppOrganizationWithUsers> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AppOrganizationWithUsers.fromJS(resultData200);
            return Promise.resolve<AppOrganizationWithUsers>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppOrganizationWithUsers>(null as any);
    }

    getNonPrivilegedUsers(id: string, cancelToken?: CancelToken): Promise<AppOrganizationWithUsers> {
        let url_ = this.baseUrl + "/api/organizations/{id}/users/common";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNonPrivilegedUsers(_response);
        });
    }

    protected processGetNonPrivilegedUsers(response: AxiosResponse): Promise<AppOrganizationWithUsers> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AppOrganizationWithUsers.fromJS(resultData200);
            return Promise.resolve<AppOrganizationWithUsers>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppOrganizationWithUsers>(null as any);
    }
}

export class ProjectClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    createProject(project: NewProject, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(project);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateProject(_response);
        });
    }

    protected processCreateProject(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    upsertProject(project: Project, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(project);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsertProject(_response);
        });
    }

    protected processUpsertProject(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getProjects( cancelToken?: CancelToken): Promise<Project[]> {
        let url_ = this.baseUrl + "/api/projects";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjects(_response);
        });
    }

    protected processGetProjects(response: AxiosResponse): Promise<Project[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Project.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Project[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Project[]>(null as any);
    }

    deleteProject(projectId: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/projects/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteProject(_response);
        });
    }

    protected processDeleteProject(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    getProject(projectId: string, cancelToken?: CancelToken): Promise<Project> {
        let url_ = this.baseUrl + "/api/projects/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProject(_response);
        });
    }

    protected processGetProject(response: AxiosResponse): Promise<Project> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Project.fromJS(resultData200);
            return Promise.resolve<Project>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Project>(null as any);
    }

    downloadDataForProcessedItem(projectId: string, id: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/dataprocess/{id}/download";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadDataForProcessedItem(_response);
        });
    }

    protected processDownloadDataForProcessedItem(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getDataProcessedForProject(projectId: string, cancelToken?: CancelToken): Promise<ProcessItem[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/dataprocess";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDataProcessedForProject(_response);
        });
    }

    protected processGetDataProcessedForProject(response: AxiosResponse): Promise<ProcessItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProcessItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProcessItem[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessItem[]>(null as any);
    }

    getDataProcess( cancelToken?: CancelToken): Promise<ProcessItem[]> {
        let url_ = this.baseUrl + "/api/projects/dataprocess";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDataProcess(_response);
        });
    }

    protected processGetDataProcess(response: AxiosResponse): Promise<ProcessItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProcessItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProcessItem[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessItem[]>(null as any);
    }
}

export class RttrClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getRttr(projectId: string, dateTime: Date | null | undefined, cancelToken?: CancelToken): Promise<RttrValue[] | null> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/rttr?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (dateTime !== undefined && dateTime !== null)
            url_ += "dateTime=" + encodeURIComponent(dateTime ? "" + dateTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRttr(_response);
        });
    }

    protected processGetRttr(response: AxiosResponse): Promise<RttrValue[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RttrValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RttrValue[] | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RttrValue[] | null>(null as any);
    }

    getRttrRange(projectId: string, cancelToken?: CancelToken): Promise<Date[] | null> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/rttr/range";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRttrRange(_response);
        });
    }

    protected processGetRttrRange(response: AxiosResponse): Promise<Date[] | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(new Date(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Date[] | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Date[] | null>(null as any);
    }

    uploadRttr(projectId: string, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/rttr/upload";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadRttr(_response);
        });
    }

    protected processUploadRttr(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class SparePartsClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    uploadFile(file: FileParameter | undefined, projectIds: string[] | undefined, locationId: string | undefined, delimiter: string | undefined, mappingsSource: string[] | undefined, mappingsTarget: string[] | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/spareparts/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (projectIds === null || projectIds === undefined)
            throw new Error("The parameter 'projectIds' cannot be null.");
        else
            projectIds.forEach(item_ => content_.append("projectIds", item_.toString()));
        if (locationId === null || locationId === undefined)
            throw new Error("The parameter 'locationId' cannot be null.");
        else
            content_.append("locationId", locationId.toString());
        if (delimiter === null || delimiter === undefined)
            throw new Error("The parameter 'delimiter' cannot be null.");
        else
            content_.append("delimiter", delimiter.toString());
        if (mappingsSource === null || mappingsSource === undefined)
            throw new Error("The parameter 'mappingsSource' cannot be null.");
        else
            mappingsSource.forEach(item_ => content_.append("mappingsSource", item_.toString()));
        if (mappingsTarget === null || mappingsTarget === undefined)
            throw new Error("The parameter 'mappingsTarget' cannot be null.");
        else
            mappingsTarget.forEach(item_ => content_.append("mappingsTarget", item_.toString()));

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadFile(_response);
        });
    }

    protected processUploadFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSparePartLocations(projectIds: string[] | undefined, cancelToken?: CancelToken): Promise<SparePartLocation[]> {
        let url_ = this.baseUrl + "/api/projects/spareparts/locations?";
        if (projectIds === null)
            throw new Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSparePartLocations(_response);
        });
    }

    protected processGetSparePartLocations(response: AxiosResponse): Promise<SparePartLocation[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SparePartLocation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SparePartLocation[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SparePartLocation[]>(null as any);
    }

    getSpareParts(projectIds: string[] | undefined, request: SparePartRequest, cancelToken?: CancelToken): Promise<SparePartGroups[]> {
        let url_ = this.baseUrl + "/api/projects/spareparts/getSpareParts?";
        if (projectIds === null)
            throw new Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSpareParts(_response);
        });
    }

    protected processGetSpareParts(response: AxiosResponse): Promise<SparePartGroups[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SparePartGroups.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SparePartGroups[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SparePartGroups[]>(null as any);
    }

    getRequiredColumns( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/projects/spareparts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRequiredColumns(_response);
        });
    }

    protected processGetRequiredColumns(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    deleteSparePart(projectIds: string[], cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/projects/spareparts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(projectIds);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSparePart(_response);
        });
    }

    protected processDeleteSparePart(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SurveyClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    parseDoBSurvey(projectId: string, file: FileParameter | undefined, surveyName: string | undefined, delimiter: string | undefined, useAsDoB: string | undefined, mappingsSource: string[] | undefined, mappingsTarget: string[] | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/survey/parse";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (surveyName === null || surveyName === undefined)
            throw new Error("The parameter 'surveyName' cannot be null.");
        else
            content_.append("surveyName", surveyName.toString());
        if (delimiter === null || delimiter === undefined)
            throw new Error("The parameter 'delimiter' cannot be null.");
        else
            content_.append("delimiter", delimiter.toString());
        if (useAsDoB === null || useAsDoB === undefined)
            throw new Error("The parameter 'useAsDoB' cannot be null.");
        else
            content_.append("useAsDoB", useAsDoB.toString());
        if (mappingsSource === null || mappingsSource === undefined)
            throw new Error("The parameter 'mappingsSource' cannot be null.");
        else
            mappingsSource.forEach(item_ => content_.append("mappingsSource", item_.toString()));
        if (mappingsTarget === null || mappingsTarget === undefined)
            throw new Error("The parameter 'mappingsTarget' cannot be null.");
        else
            mappingsTarget.forEach(item_ => content_.append("mappingsTarget", item_.toString()));

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processParseDoBSurvey(_response);
        });
    }

    protected processParseDoBSurvey(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteSurvey(projectId: string, id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/survey/{id}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSurvey(_response);
        });
    }

    protected processDeleteSurvey(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteSurvey2(projectId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/survey";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSurvey2(_response);
        });
    }

    protected processDeleteSurvey2(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getSurveys(projectId: string, cancelToken?: CancelToken): Promise<SurveyInfo[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/surveys";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSurveys(_response);
        });
    }

    protected processGetSurveys(response: AxiosResponse): Promise<SurveyInfo[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SurveyInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SurveyInfo[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyInfo[]>(null as any);
    }

    doBForSurvey(projectId: string, ids: string[] | undefined, filter: ChartFilter, cancelToken?: CancelToken): Promise<SurveyDoBChart> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/survey/dob?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDoBForSurvey(_response);
        });
    }

    protected processDoBForSurvey(response: AxiosResponse): Promise<SurveyDoBChart> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SurveyDoBChart.fromJS(resultData200);
            return Promise.resolve<SurveyDoBChart>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyDoBChart>(null as any);
    }

    getRequiredColumns( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/projects/surveys";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRequiredColumns(_response);
        });
    }

    protected processGetRequiredColumns(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class UserClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    currentUser( cancelToken?: CancelToken): Promise<CurrentUser> {
        let url_ = this.baseUrl + "/api/users/current/info";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCurrentUser(_response);
        });
    }

    protected processCurrentUser(response: AxiosResponse): Promise<CurrentUser> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CurrentUser.fromJS(resultData200);
            return Promise.resolve<CurrentUser>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CurrentUser>(null as any);
    }

    setUserAccess(item: AppUserAccess, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/user/access";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetUserAccess(_response);
        });
    }

    protected processSetUserAccess(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    sendUserAccessMail(recipientAddress: string | undefined, organisationName: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/user/access/mail?";
        if (recipientAddress === null)
            throw new Error("The parameter 'recipientAddress' cannot be null.");
        else if (recipientAddress !== undefined)
            url_ += "recipientAddress=" + encodeURIComponent("" + recipientAddress) + "&";
        if (organisationName === null)
            throw new Error("The parameter 'organisationName' cannot be null.");
        else if (organisationName !== undefined)
            url_ += "organisationName=" + encodeURIComponent("" + organisationName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendUserAccessMail(_response);
        });
    }

    protected processSendUserAccessMail(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    removeUserAccess(id: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/user/{id}/access";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveUserAccess(_response);
        });
    }

    protected processRemoveUserAccess(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    setUserAccessBulk(items: AppUserAccess[], cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/users/access";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(items);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetUserAccessBulk(_response);
        });
    }

    protected processSetUserAccessBulk(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getUsers( cancelToken?: CancelToken): Promise<AppUser[]> {
        let url_ = this.baseUrl + "/api/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: AxiosResponse): Promise<AppUser[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppUser.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AppUser[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppUser[]>(null as any);
    }
}

export class VesselClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    vesselInfo(projectId: string, request: VesselInfoRequest, cancelToken?: CancelToken): Promise<VesselInfo> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/vessels/info";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVesselInfo(_response);
        });
    }

    protected processVesselInfo(response: AxiosResponse): Promise<VesselInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VesselInfo.fromJS(resultData200);
            return Promise.resolve<VesselInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VesselInfo>(null as any);
    }

    vesselsAroundCable(projectId: string, timestamp: Date | null | undefined, cancelToken?: CancelToken): Promise<CableVessel[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/vessels?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (timestamp !== undefined && timestamp !== null)
            url_ += "timestamp=" + encodeURIComponent(timestamp ? "" + timestamp.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVesselsAroundCable(_response);
        });
    }

    protected processVesselsAroundCable(response: AxiosResponse): Promise<CableVessel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CableVessel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CableVessel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CableVessel[]>(null as any);
    }
}

export class OpenApiClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getOpenApiDefinition(apiTitle: string | null | undefined, version: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/openapi?";
        if (apiTitle !== undefined && apiTitle !== null)
            url_ += "apiTitle=" + encodeURIComponent("" + apiTitle) + "&";
        if (version !== undefined && version !== null)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOpenApiDefinition(_response);
        });
    }

    protected processGetOpenApiDefinition(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getOpenApiDefinitionForPostman(apiTitle: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/openapi/postman?";
        if (apiTitle !== undefined && apiTitle !== null)
            url_ += "apiTitle=" + encodeURIComponent("" + apiTitle) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOpenApiDefinitionForPostman(_response);
        });
    }

    protected processGetOpenApiDefinitionForPostman(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getOpenApiDefinitionWithGroupNamesFromBody(group: ApiGroupNames | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/openapi/apigroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(group);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOpenApiDefinitionWithGroupNamesFromBody(_response);
        });
    }

    protected processGetOpenApiDefinitionWithGroupNamesFromBody(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getOpenApiDefinitionWithGroupNamesFromQuery(groupNames: string[] | null | undefined, version: string | null | undefined, includeSecurityInfo: boolean | undefined, apiTitle: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/openapi/apigroups?";
        if (groupNames !== undefined && groupNames !== null)
            groupNames && groupNames.forEach(item => { url_ += "groupNames=" + encodeURIComponent("" + item) + "&"; });
        if (version !== undefined && version !== null)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        if (includeSecurityInfo === null)
            throw new Error("The parameter 'includeSecurityInfo' cannot be null.");
        else if (includeSecurityInfo !== undefined)
            url_ += "includeSecurityInfo=" + encodeURIComponent("" + includeSecurityInfo) + "&";
        if (apiTitle !== undefined && apiTitle !== null)
            url_ += "apiTitle=" + encodeURIComponent("" + apiTitle) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOpenApiDefinitionWithGroupNamesFromQuery(_response);
        });
    }

    protected processGetOpenApiDefinitionWithGroupNamesFromQuery(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getOpenApiDefinitionForInternalApi(apiTitle: string | null | undefined, includeSecurityInfo: boolean | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/openapi/internals?";
        if (apiTitle !== undefined && apiTitle !== null)
            url_ += "apiTitle=" + encodeURIComponent("" + apiTitle) + "&";
        if (includeSecurityInfo === null)
            throw new Error("The parameter 'includeSecurityInfo' cannot be null.");
        else if (includeSecurityInfo !== undefined)
            url_ += "includeSecurityInfo=" + encodeURIComponent("" + includeSecurityInfo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOpenApiDefinitionForInternalApi(_response);
        });
    }

    protected processGetOpenApiDefinitionForInternalApi(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class AuthenticationClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getMyAuthenticationInfo( cancelToken?: CancelToken): Promise<UserAuthenticationInfo> {
        let url_ = this.baseUrl + "/api/authentication/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyAuthenticationInfo(_response);
        });
    }

    protected processGetMyAuthenticationInfo(response: AxiosResponse): Promise<UserAuthenticationInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserAuthenticationInfo.fromJS(resultData200);
            return Promise.resolve<UserAuthenticationInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserAuthenticationInfo>(null as any);
    }
}

export class MonitoringClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getHealthStatus(fullClassName: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/health?";
        if (fullClassName !== undefined && fullClassName !== null)
            url_ += "fullClassName=" + encodeURIComponent("" + fullClassName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHealthStatus(_response);
        });
    }

    protected processGetHealthStatus(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSmokeStatus( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/smoke";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSmokeStatus(_response);
        });
    }

    protected processGetSmokeStatus(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getBuildIdentifier( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/buildidentifier";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBuildIdentifier(_response);
        });
    }

    protected processGetBuildIdentifier(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    testConnection( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/testconnection";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestConnection(_response);
        });
    }

    protected processTestConnection(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class AlarmConfiguration implements IAlarmConfiguration {
    id?: string | undefined;
    projectId!: string;
    description?: string | undefined;
    type!: AlarmConfigurationType;
    severity?: AlarmSeverity | undefined;
    created?: Date | undefined;
    sparePartAlarmConfiguration?: SparePartAlarmConfigurationData | undefined;
    makeSenseAlarmConfiguration?: MakeSenseAlarmConfigurationData | undefined;

    constructor(data?: IAlarmConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.severity = _data["severity"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.sparePartAlarmConfiguration = _data["sparePartAlarmConfiguration"] ? SparePartAlarmConfigurationData.fromJS(_data["sparePartAlarmConfiguration"]) : <any>undefined;
            this.makeSenseAlarmConfiguration = _data["makeSenseAlarmConfiguration"] ? MakeSenseAlarmConfigurationData.fromJS(_data["makeSenseAlarmConfiguration"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AlarmConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["description"] = this.description;
        data["type"] = this.type;
        data["severity"] = this.severity;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["sparePartAlarmConfiguration"] = this.sparePartAlarmConfiguration ? this.sparePartAlarmConfiguration.toJSON() : <any>undefined;
        data["makeSenseAlarmConfiguration"] = this.makeSenseAlarmConfiguration ? this.makeSenseAlarmConfiguration.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAlarmConfiguration {
    id?: string | undefined;
    projectId: string;
    description?: string | undefined;
    type: AlarmConfigurationType;
    severity?: AlarmSeverity | undefined;
    created?: Date | undefined;
    sparePartAlarmConfiguration?: SparePartAlarmConfigurationData | undefined;
    makeSenseAlarmConfiguration?: MakeSenseAlarmConfigurationData | undefined;
}

export enum AlarmConfigurationType {
    SpareParts = "SpareParts",
    MakeSense = "MakeSense",
}

export enum AlarmSeverity {
    LowSeverity = "LowSeverity",
    MediumSeverity = "MediumSeverity",
    HighSeverity = "HighSeverity",
}

export class SparePartAlarmConfigurationData implements ISparePartAlarmConfigurationData {
    name?: string | undefined;
    expiration!: number;

    constructor(data?: ISparePartAlarmConfigurationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.expiration = _data["expiration"];
        }
    }

    static fromJS(data: any): SparePartAlarmConfigurationData {
        data = typeof data === 'object' ? data : {};
        let result = new SparePartAlarmConfigurationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["expiration"] = this.expiration;
        return data;
    }
}

export interface ISparePartAlarmConfigurationData {
    name?: string | undefined;
    expiration: number;
}

export class MakeSenseAlarmConfigurationData implements IMakeSenseAlarmConfigurationData {
    dobSeverity?: DoBAlarmTrigger | undefined;
    dasSeverity?: DASAlarmTrigger | undefined;
    aisSeverity?: AISAlarmTrigger | undefined;
    dtsSeverity?: DTSAlarmTrigger | undefined;
    proximity!: number;

    constructor(data?: IMakeSenseAlarmConfigurationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dobSeverity = _data["dobSeverity"] ? DoBAlarmTrigger.fromJS(_data["dobSeverity"]) : <any>undefined;
            this.dasSeverity = _data["dasSeverity"] ? DASAlarmTrigger.fromJS(_data["dasSeverity"]) : <any>undefined;
            this.aisSeverity = _data["aisSeverity"] ? AISAlarmTrigger.fromJS(_data["aisSeverity"]) : <any>undefined;
            this.dtsSeverity = _data["dtsSeverity"] ? DTSAlarmTrigger.fromJS(_data["dtsSeverity"]) : <any>undefined;
            this.proximity = _data["proximity"];
        }
    }

    static fromJS(data: any): MakeSenseAlarmConfigurationData {
        data = typeof data === 'object' ? data : {};
        let result = new MakeSenseAlarmConfigurationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dobSeverity"] = this.dobSeverity ? this.dobSeverity.toJSON() : <any>undefined;
        data["dasSeverity"] = this.dasSeverity ? this.dasSeverity.toJSON() : <any>undefined;
        data["aisSeverity"] = this.aisSeverity ? this.aisSeverity.toJSON() : <any>undefined;
        data["dtsSeverity"] = this.dtsSeverity ? this.dtsSeverity.toJSON() : <any>undefined;
        data["proximity"] = this.proximity;
        return data;
    }
}

export interface IMakeSenseAlarmConfigurationData {
    dobSeverity?: DoBAlarmTrigger | undefined;
    dasSeverity?: DASAlarmTrigger | undefined;
    aisSeverity?: AISAlarmTrigger | undefined;
    dtsSeverity?: DTSAlarmTrigger | undefined;
    proximity: number;
}

export class DoBAlarmTrigger implements IDoBAlarmTrigger {
    isActive?: boolean | undefined;
    severity?: DoBAlarmSeverity | undefined;

    constructor(data?: IDoBAlarmTrigger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"];
            this.severity = _data["severity"];
        }
    }

    static fromJS(data: any): DoBAlarmTrigger {
        data = typeof data === 'object' ? data : {};
        let result = new DoBAlarmTrigger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["severity"] = this.severity;
        return data;
    }
}

export interface IDoBAlarmTrigger {
    isActive?: boolean | undefined;
    severity?: DoBAlarmSeverity | undefined;
}

export enum DoBAlarmSeverity {
    Buried = "Buried",
    PartiallyBuried = "PartiallyBuried",
    Exposed = "Exposed",
}

export class DASAlarmTrigger implements IDASAlarmTrigger {
    isActive?: boolean | undefined;
    severity?: AlarmSeverity | undefined;

    constructor(data?: IDASAlarmTrigger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"];
            this.severity = _data["severity"];
        }
    }

    static fromJS(data: any): DASAlarmTrigger {
        data = typeof data === 'object' ? data : {};
        let result = new DASAlarmTrigger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["severity"] = this.severity;
        return data;
    }
}

export interface IDASAlarmTrigger {
    isActive?: boolean | undefined;
    severity?: AlarmSeverity | undefined;
}

export class AISAlarmTrigger implements IAISAlarmTrigger {
    isActive?: boolean | undefined;
    severity?: AlarmSeverity | undefined;

    constructor(data?: IAISAlarmTrigger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"];
            this.severity = _data["severity"];
        }
    }

    static fromJS(data: any): AISAlarmTrigger {
        data = typeof data === 'object' ? data : {};
        let result = new AISAlarmTrigger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["severity"] = this.severity;
        return data;
    }
}

export interface IAISAlarmTrigger {
    isActive?: boolean | undefined;
    severity?: AlarmSeverity | undefined;
}

export class DTSAlarmTrigger implements IDTSAlarmTrigger {
    isActive?: boolean | undefined;
    severity?: AlarmSeverity | undefined;

    constructor(data?: IDTSAlarmTrigger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"];
            this.severity = _data["severity"];
        }
    }

    static fromJS(data: any): DTSAlarmTrigger {
        data = typeof data === 'object' ? data : {};
        let result = new DTSAlarmTrigger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["severity"] = this.severity;
        return data;
    }
}

export interface IDTSAlarmTrigger {
    isActive?: boolean | undefined;
    severity?: AlarmSeverity | undefined;
}

export class NewAlarmConfiguration implements INewAlarmConfiguration {
    projectId!: string;
    type!: AlarmConfigurationType;

    constructor(data?: INewAlarmConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): NewAlarmConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new NewAlarmConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["type"] = this.type;
        return data;
    }
}

export interface INewAlarmConfiguration {
    projectId: string;
    type: AlarmConfigurationType;
}

export class Alarm implements IAlarm {
    projectId!: string;
    id!: string;
    externalId?: string | undefined;
    kp?: number | undefined;
    timestamp!: Date;
    startTimestamp!: Date;
    hasRange!: boolean;
    description!: string;
    coordinate?: Coordinate | undefined;
    active!: boolean;
    visited!: boolean;
    makeSenseAlarmSeverity?: AlarmSeverity | undefined;
    alarmSeverity!: AlarmSeverity;
    isMakeSenseAlarm!: boolean;
    alarmSource!: AlarmSource;
    alarmSources!: AlarmSource[];
    logs!: AlarmActivationLog[];
    aisData?: AlarmAISData | undefined;
    sparePartData?: AlarmSparepartData | undefined;
    dtsData?: AlarmDtsData | undefined;

    constructor(data?: IAlarm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.alarmSource = new AlarmSource();
            this.alarmSources = [];
            this.logs = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.id = _data["id"];
            this.externalId = _data["externalId"];
            this.kp = _data["kp"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.startTimestamp = _data["startTimestamp"] ? new Date(_data["startTimestamp"].toString()) : <any>undefined;
            this.hasRange = _data["hasRange"];
            this.description = _data["description"];
            this.coordinate = _data["coordinate"] ? Coordinate.fromJS(_data["coordinate"]) : <any>undefined;
            this.active = _data["active"];
            this.visited = _data["visited"];
            this.makeSenseAlarmSeverity = _data["makeSenseAlarmSeverity"];
            this.alarmSeverity = _data["alarmSeverity"];
            this.isMakeSenseAlarm = _data["isMakeSenseAlarm"];
            this.alarmSource = _data["alarmSource"] ? AlarmSource.fromJS(_data["alarmSource"]) : new AlarmSource();
            if (Array.isArray(_data["alarmSources"])) {
                this.alarmSources = [] as any;
                for (let item of _data["alarmSources"])
                    this.alarmSources!.push(AlarmSource.fromJS(item));
            }
            if (Array.isArray(_data["logs"])) {
                this.logs = [] as any;
                for (let item of _data["logs"])
                    this.logs!.push(AlarmActivationLog.fromJS(item));
            }
            this.aisData = _data["aisData"] ? AlarmAISData.fromJS(_data["aisData"]) : <any>undefined;
            this.sparePartData = _data["sparePartData"] ? AlarmSparepartData.fromJS(_data["sparePartData"]) : <any>undefined;
            this.dtsData = _data["dtsData"] ? AlarmDtsData.fromJS(_data["dtsData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Alarm {
        data = typeof data === 'object' ? data : {};
        let result = new Alarm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["id"] = this.id;
        data["externalId"] = this.externalId;
        data["kp"] = this.kp;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["startTimestamp"] = this.startTimestamp ? this.startTimestamp.toISOString() : <any>undefined;
        data["hasRange"] = this.hasRange;
        data["description"] = this.description;
        data["coordinate"] = this.coordinate ? this.coordinate.toJSON() : <any>undefined;
        data["active"] = this.active;
        data["visited"] = this.visited;
        data["makeSenseAlarmSeverity"] = this.makeSenseAlarmSeverity;
        data["alarmSeverity"] = this.alarmSeverity;
        data["isMakeSenseAlarm"] = this.isMakeSenseAlarm;
        data["alarmSource"] = this.alarmSource ? this.alarmSource.toJSON() : <any>undefined;
        if (Array.isArray(this.alarmSources)) {
            data["alarmSources"] = [];
            for (let item of this.alarmSources)
                data["alarmSources"].push(item.toJSON());
        }
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item.toJSON());
        }
        data["aisData"] = this.aisData ? this.aisData.toJSON() : <any>undefined;
        data["sparePartData"] = this.sparePartData ? this.sparePartData.toJSON() : <any>undefined;
        data["dtsData"] = this.dtsData ? this.dtsData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAlarm {
    projectId: string;
    id: string;
    externalId?: string | undefined;
    kp?: number | undefined;
    timestamp: Date;
    startTimestamp: Date;
    hasRange: boolean;
    description: string;
    coordinate?: Coordinate | undefined;
    active: boolean;
    visited: boolean;
    makeSenseAlarmSeverity?: AlarmSeverity | undefined;
    alarmSeverity: AlarmSeverity;
    isMakeSenseAlarm: boolean;
    alarmSource: AlarmSource;
    alarmSources: AlarmSource[];
    logs: AlarmActivationLog[];
    aisData?: AlarmAISData | undefined;
    sparePartData?: AlarmSparepartData | undefined;
    dtsData?: AlarmDtsData | undefined;
}

export class Coordinate implements ICoordinate {
    longitude!: number;
    latitude!: number;
    easting!: number;
    northing!: number;

    constructor(data?: ICoordinate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.easting = _data["easting"];
            this.northing = _data["northing"];
        }
    }

    static fromJS(data: any): Coordinate {
        data = typeof data === 'object' ? data : {};
        let result = new Coordinate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["easting"] = this.easting;
        data["northing"] = this.northing;
        return data;
    }
}

export interface ICoordinate {
    longitude: number;
    latitude: number;
    easting: number;
    northing: number;
}

export class AlarmSource implements IAlarmSource {
    type!: AlarmSourceType;
    severity!: AlarmSeverity;

    constructor(data?: IAlarmSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.severity = _data["severity"];
        }
    }

    static fromJS(data: any): AlarmSource {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["severity"] = this.severity;
        return data;
    }
}

export interface IAlarmSource {
    type: AlarmSourceType;
    severity: AlarmSeverity;
}

export enum AlarmSourceType {
    AIS = "AIS",
    DTS = "DTS",
    DAS = "DAS",
    DoB = "DoB",
    SpareParts = "SpareParts",
    MakeSense = "MakeSense",
}

export class AlarmActivationLog implements IAlarmActivationLog {
    changedBy?: UserInfo | undefined;
    comment?: string | undefined;
    timestamp!: Date;
    type!: AlarmActivationType;

    constructor(data?: IAlarmActivationLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.changedBy = _data["changedBy"] ? UserInfo.fromJS(_data["changedBy"]) : <any>undefined;
            this.comment = _data["comment"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): AlarmActivationLog {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmActivationLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["changedBy"] = this.changedBy ? this.changedBy.toJSON() : <any>undefined;
        data["comment"] = this.comment;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["type"] = this.type;
        return data;
    }
}

export interface IAlarmActivationLog {
    changedBy?: UserInfo | undefined;
    comment?: string | undefined;
    timestamp: Date;
    type: AlarmActivationType;
}

export class UserInfo implements IUserInfo {
    userId?: string | undefined;
    name?: string | undefined;

    constructor(data?: IUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["name"] = this.name;
        return data;
    }
}

export interface IUserInfo {
    userId?: string | undefined;
    name?: string | undefined;
}

export enum AlarmActivationType {
    Activate = "Activate",
    Deactivate = "Deactivate",
}

export class AlarmAISData implements IAlarmAISData {
    vesselName?: string | undefined;
    comment?: string | undefined;
    mmsi!: number;
    destination?: string | undefined;
    speedOverGround?: number | undefined;
    courseOverGround?: number | undefined;
    radioCallSign?: string | undefined;
    breadth?: number | undefined;
    length?: number | undefined;
    ruleGroup?: string | undefined;
    vesselType?: string | undefined;
    zone?: string | undefined;
    vessel?: CableVessel | undefined;

    constructor(data?: IAlarmAISData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vesselName = _data["vesselName"];
            this.comment = _data["comment"];
            this.mmsi = _data["mmsi"];
            this.destination = _data["destination"];
            this.speedOverGround = _data["speedOverGround"];
            this.courseOverGround = _data["courseOverGround"];
            this.radioCallSign = _data["radioCallSign"];
            this.breadth = _data["breadth"];
            this.length = _data["length"];
            this.ruleGroup = _data["ruleGroup"];
            this.vesselType = _data["vesselType"];
            this.zone = _data["zone"];
            this.vessel = _data["vessel"] ? CableVessel.fromJS(_data["vessel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AlarmAISData {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmAISData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vesselName"] = this.vesselName;
        data["comment"] = this.comment;
        data["mmsi"] = this.mmsi;
        data["destination"] = this.destination;
        data["speedOverGround"] = this.speedOverGround;
        data["courseOverGround"] = this.courseOverGround;
        data["radioCallSign"] = this.radioCallSign;
        data["breadth"] = this.breadth;
        data["length"] = this.length;
        data["ruleGroup"] = this.ruleGroup;
        data["vesselType"] = this.vesselType;
        data["zone"] = this.zone;
        data["vessel"] = this.vessel ? this.vessel.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAlarmAISData {
    vesselName?: string | undefined;
    comment?: string | undefined;
    mmsi: number;
    destination?: string | undefined;
    speedOverGround?: number | undefined;
    courseOverGround?: number | undefined;
    radioCallSign?: string | undefined;
    breadth?: number | undefined;
    length?: number | undefined;
    ruleGroup?: string | undefined;
    vesselType?: string | undefined;
    zone?: string | undefined;
    vessel?: CableVessel | undefined;
}

export class CableVessel implements ICableVessel {
    vesselName?: string | undefined;
    angle!: number;
    easting!: number;
    northing!: number;
    vesselType!: number;
    mmsi!: number;
    timestamp!: Date;

    constructor(data?: ICableVessel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vesselName = _data["vesselName"];
            this.angle = _data["angle"];
            this.easting = _data["easting"];
            this.northing = _data["northing"];
            this.vesselType = _data["vesselType"];
            this.mmsi = _data["mmsi"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CableVessel {
        data = typeof data === 'object' ? data : {};
        let result = new CableVessel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vesselName"] = this.vesselName;
        data["angle"] = this.angle;
        data["easting"] = this.easting;
        data["northing"] = this.northing;
        data["vesselType"] = this.vesselType;
        data["mmsi"] = this.mmsi;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICableVessel {
    vesselName?: string | undefined;
    angle: number;
    easting: number;
    northing: number;
    vesselType: number;
    mmsi: number;
    timestamp: Date;
}

export class AlarmSparepartData implements IAlarmSparepartData {
    expirationDate?: Date | undefined;
    sparePartGroups!: SparePartGroups[];

    constructor(data?: IAlarmSparepartData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sparePartGroups = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["sparePartGroups"])) {
                this.sparePartGroups = [] as any;
                for (let item of _data["sparePartGroups"])
                    this.sparePartGroups!.push(SparePartGroups.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AlarmSparepartData {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmSparepartData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        if (Array.isArray(this.sparePartGroups)) {
            data["sparePartGroups"] = [];
            for (let item of this.sparePartGroups)
                data["sparePartGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAlarmSparepartData {
    expirationDate?: Date | undefined;
    sparePartGroups: SparePartGroups[];
}

export class SparePartGroups implements ISparePartGroups {
    spareName?: string | undefined;
    earliestExpiry?: Date | undefined;
    isExpired!: boolean;
    location?: string | undefined;
    spareParts?: SparePart[] | undefined;

    constructor(data?: ISparePartGroups) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.spareName = _data["spareName"];
            this.earliestExpiry = _data["earliestExpiry"] ? new Date(_data["earliestExpiry"].toString()) : <any>undefined;
            this.isExpired = _data["isExpired"];
            this.location = _data["location"];
            if (Array.isArray(_data["spareParts"])) {
                this.spareParts = [] as any;
                for (let item of _data["spareParts"])
                    this.spareParts!.push(SparePart.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SparePartGroups {
        data = typeof data === 'object' ? data : {};
        let result = new SparePartGroups();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["spareName"] = this.spareName;
        data["earliestExpiry"] = this.earliestExpiry ? this.earliestExpiry.toISOString() : <any>undefined;
        data["isExpired"] = this.isExpired;
        data["location"] = this.location;
        if (Array.isArray(this.spareParts)) {
            data["spareParts"] = [];
            for (let item of this.spareParts)
                data["spareParts"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISparePartGroups {
    spareName?: string | undefined;
    earliestExpiry?: Date | undefined;
    isExpired: boolean;
    location?: string | undefined;
    spareParts?: SparePart[] | undefined;
}

export class SparePart implements ISparePart {
    spareName?: string | undefined;
    subcategory?: string | undefined;
    location?: string | undefined;
    identity?: string | undefined;
    description?: string | undefined;
    unit?: string | undefined;
    position?: string | undefined;
    quantity?: string | undefined;
    deliveryDate?: Date | undefined;
    expiryDate?: Date | undefined;
    lastInspectionBy?: string | undefined;
    lastInspection?: Date | undefined;
    nextInspection?: Date | undefined;
    storageDescription?: string | undefined;
    customLeadTime?: string | undefined;
    relatedProjects!: string[];
    isExpired!: boolean;
    customerDocNo?: string | undefined;
    cusotmerBarCode?: string | undefined;
    boxPalletLabel?: string | undefined;
    boxPalletNo?: string | undefined;
    poRefeNo?: string | undefined;
    deliveryCertNo?: string | undefined;
    manufacturer?: string | undefined;
    nktBarCode?: string | undefined;
    notes?: string | undefined;

    constructor(data?: ISparePart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.relatedProjects = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.spareName = _data["spareName"];
            this.subcategory = _data["subcategory"];
            this.location = _data["location"];
            this.identity = _data["identity"];
            this.description = _data["description"];
            this.unit = _data["unit"];
            this.position = _data["position"];
            this.quantity = _data["quantity"];
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : <any>undefined;
            this.expiryDate = _data["expiryDate"] ? new Date(_data["expiryDate"].toString()) : <any>undefined;
            this.lastInspectionBy = _data["lastInspectionBy"];
            this.lastInspection = _data["lastInspection"] ? new Date(_data["lastInspection"].toString()) : <any>undefined;
            this.nextInspection = _data["nextInspection"] ? new Date(_data["nextInspection"].toString()) : <any>undefined;
            this.storageDescription = _data["storageDescription"];
            this.customLeadTime = _data["customLeadTime"];
            if (Array.isArray(_data["relatedProjects"])) {
                this.relatedProjects = [] as any;
                for (let item of _data["relatedProjects"])
                    this.relatedProjects!.push(item);
            }
            this.isExpired = _data["isExpired"];
            this.customerDocNo = _data["customerDocNo"];
            this.cusotmerBarCode = _data["cusotmerBarCode"];
            this.boxPalletLabel = _data["boxPalletLabel"];
            this.boxPalletNo = _data["boxPalletNo"];
            this.poRefeNo = _data["poRefeNo"];
            this.deliveryCertNo = _data["deliveryCertNo"];
            this.manufacturer = _data["manufacturer"];
            this.nktBarCode = _data["nktBarCode"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): SparePart {
        data = typeof data === 'object' ? data : {};
        let result = new SparePart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["spareName"] = this.spareName;
        data["subcategory"] = this.subcategory;
        data["location"] = this.location;
        data["identity"] = this.identity;
        data["description"] = this.description;
        data["unit"] = this.unit;
        data["position"] = this.position;
        data["quantity"] = this.quantity;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : <any>undefined;
        data["lastInspectionBy"] = this.lastInspectionBy;
        data["lastInspection"] = this.lastInspection ? this.lastInspection.toISOString() : <any>undefined;
        data["nextInspection"] = this.nextInspection ? this.nextInspection.toISOString() : <any>undefined;
        data["storageDescription"] = this.storageDescription;
        data["customLeadTime"] = this.customLeadTime;
        if (Array.isArray(this.relatedProjects)) {
            data["relatedProjects"] = [];
            for (let item of this.relatedProjects)
                data["relatedProjects"].push(item);
        }
        data["isExpired"] = this.isExpired;
        data["customerDocNo"] = this.customerDocNo;
        data["cusotmerBarCode"] = this.cusotmerBarCode;
        data["boxPalletLabel"] = this.boxPalletLabel;
        data["boxPalletNo"] = this.boxPalletNo;
        data["poRefeNo"] = this.poRefeNo;
        data["deliveryCertNo"] = this.deliveryCertNo;
        data["manufacturer"] = this.manufacturer;
        data["nktBarCode"] = this.nktBarCode;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ISparePart {
    spareName?: string | undefined;
    subcategory?: string | undefined;
    location?: string | undefined;
    identity?: string | undefined;
    description?: string | undefined;
    unit?: string | undefined;
    position?: string | undefined;
    quantity?: string | undefined;
    deliveryDate?: Date | undefined;
    expiryDate?: Date | undefined;
    lastInspectionBy?: string | undefined;
    lastInspection?: Date | undefined;
    nextInspection?: Date | undefined;
    storageDescription?: string | undefined;
    customLeadTime?: string | undefined;
    relatedProjects: string[];
    isExpired: boolean;
    customerDocNo?: string | undefined;
    cusotmerBarCode?: string | undefined;
    boxPalletLabel?: string | undefined;
    boxPalletNo?: string | undefined;
    poRefeNo?: string | undefined;
    deliveryCertNo?: string | undefined;
    manufacturer?: string | undefined;
    nktBarCode?: string | undefined;
    notes?: string | undefined;
}

export class AlarmDtsData implements IAlarmDtsData {
    dtsType!: DTSType;

    constructor(data?: IAlarmDtsData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dtsType = _data["dtsType"];
        }
    }

    static fromJS(data: any): AlarmDtsData {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmDtsData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dtsType"] = this.dtsType;
        return data;
    }
}

export interface IAlarmDtsData {
    dtsType: DTSType;
}

export enum DTSType {
    ConductorTemperature = "ConductorTemperature",
    FiberTemperature = "FiberTemperature",
}

export class AlarmFilter implements IAlarmFilter {
    alarmTypes!: AlarmSourceType[];
    minDate?: Date | undefined;
    maxDate?: Date | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IAlarmFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.alarmTypes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["alarmTypes"])) {
                this.alarmTypes = [] as any;
                for (let item of _data["alarmTypes"])
                    this.alarmTypes!.push(item);
            }
            this.minDate = _data["minDate"] ? new Date(_data["minDate"].toString()) : <any>undefined;
            this.maxDate = _data["maxDate"] ? new Date(_data["maxDate"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): AlarmFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.alarmTypes)) {
            data["alarmTypes"] = [];
            for (let item of this.alarmTypes)
                data["alarmTypes"].push(item);
        }
        data["minDate"] = this.minDate ? this.minDate.toISOString() : <any>undefined;
        data["maxDate"] = this.maxDate ? this.maxDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IAlarmFilter {
    alarmTypes: AlarmSourceType[];
    minDate?: Date | undefined;
    maxDate?: Date | undefined;
    isActive?: boolean | undefined;
}

export class UpdateActivationRequest implements IUpdateActivationRequest {
    action!: AlarmActivationType;
    comment?: string | undefined;

    constructor(data?: IUpdateActivationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): UpdateActivationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateActivationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IUpdateActivationRequest {
    action: AlarmActivationType;
    comment?: string | undefined;
}

export class BulkActivationResult implements IBulkActivationResult {
    success!: boolean;
    successCount!: number;
    failureCount!: number;
    totalCount!: number;
    failedAlarmIds!: string[];
    errorMessage?: string | undefined;

    constructor(data?: IBulkActivationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.failedAlarmIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.successCount = _data["successCount"];
            this.failureCount = _data["failureCount"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["failedAlarmIds"])) {
                this.failedAlarmIds = [] as any;
                for (let item of _data["failedAlarmIds"])
                    this.failedAlarmIds!.push(item);
            }
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): BulkActivationResult {
        data = typeof data === 'object' ? data : {};
        let result = new BulkActivationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["successCount"] = this.successCount;
        data["failureCount"] = this.failureCount;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.failedAlarmIds)) {
            data["failedAlarmIds"] = [];
            for (let item of this.failedAlarmIds)
                data["failedAlarmIds"].push(item);
        }
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IBulkActivationResult {
    success: boolean;
    successCount: number;
    failureCount: number;
    totalCount: number;
    failedAlarmIds: string[];
    errorMessage?: string | undefined;
}

export class BulkUpdateActivationRequest implements IBulkUpdateActivationRequest {
    action!: AlarmActivationType;
    comment?: string | undefined;
    alarmIds!: string[];

    constructor(data?: IBulkUpdateActivationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.alarmIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            this.comment = _data["comment"];
            if (Array.isArray(_data["alarmIds"])) {
                this.alarmIds = [] as any;
                for (let item of _data["alarmIds"])
                    this.alarmIds!.push(item);
            }
        }
    }

    static fromJS(data: any): BulkUpdateActivationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BulkUpdateActivationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["comment"] = this.comment;
        if (Array.isArray(this.alarmIds)) {
            data["alarmIds"] = [];
            for (let item of this.alarmIds)
                data["alarmIds"].push(item);
        }
        return data;
    }
}

export interface IBulkUpdateActivationRequest {
    action: AlarmActivationType;
    comment?: string | undefined;
    alarmIds: string[];
}

export class DTSChart implements IDTSChart {
    series!: DataSeries[];

    constructor(data?: IDTSChart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.series = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["series"])) {
                this.series = [] as any;
                for (let item of _data["series"])
                    this.series!.push(DataSeries.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DTSChart {
        data = typeof data === 'object' ? data : {};
        let result = new DTSChart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.series)) {
            data["series"] = [];
            for (let item of this.series)
                data["series"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDTSChart {
    series: DataSeries[];
}

export class AlarmDTSChart extends DTSChart implements IAlarmDTSChart {
    id!: string;
    areaOfInterest!: AreaOfInterest;

    constructor(data?: IAlarmDTSChart) {
        super(data);
        if (!data) {
            this.areaOfInterest = new AreaOfInterest();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.areaOfInterest = _data["areaOfInterest"] ? AreaOfInterest.fromJS(_data["areaOfInterest"]) : new AreaOfInterest();
        }
    }

    static override fromJS(data: any): AlarmDTSChart {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmDTSChart();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["areaOfInterest"] = this.areaOfInterest ? this.areaOfInterest.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAlarmDTSChart extends IDTSChart {
    id: string;
    areaOfInterest: AreaOfInterest;
}

export class AreaOfInterest implements IAreaOfInterest {
    kp!: number;
    minKP!: number;
    maxKP!: number;
    minKPIndex?: number | undefined;
    maxKPIndex?: number | undefined;

    constructor(data?: IAreaOfInterest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kp = _data["kp"];
            this.minKP = _data["minKP"];
            this.maxKP = _data["maxKP"];
            this.minKPIndex = _data["minKPIndex"];
            this.maxKPIndex = _data["maxKPIndex"];
        }
    }

    static fromJS(data: any): AreaOfInterest {
        data = typeof data === 'object' ? data : {};
        let result = new AreaOfInterest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kp"] = this.kp;
        data["minKP"] = this.minKP;
        data["maxKP"] = this.maxKP;
        data["minKPIndex"] = this.minKPIndex;
        data["maxKPIndex"] = this.maxKPIndex;
        return data;
    }
}

export interface IAreaOfInterest {
    kp: number;
    minKP: number;
    maxKP: number;
    minKPIndex?: number | undefined;
    maxKPIndex?: number | undefined;
}

export class DataSeries implements IDataSeries {
    name!: string;
    values!: number[][];

    constructor(data?: IDataSeries) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.values = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static fromJS(data: any): DataSeries {
        data = typeof data === 'object' ? data : {};
        let result = new DataSeries();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        return data;
    }
}

export interface IDataSeries {
    name: string;
    values: number[][];
}

export class DASChart implements IDASChart {
    yData!: Date[];
    xData!: number[];
    data!: Point[];

    constructor(data?: IDASChart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.yData = [];
            this.xData = [];
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["yData"])) {
                this.yData = [] as any;
                for (let item of _data["yData"])
                    this.yData!.push(new Date(item));
            }
            if (Array.isArray(_data["xData"])) {
                this.xData = [] as any;
                for (let item of _data["xData"])
                    this.xData!.push(item);
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Point.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DASChart {
        data = typeof data === 'object' ? data : {};
        let result = new DASChart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.yData)) {
            data["yData"] = [];
            for (let item of this.yData)
                data["yData"].push(item.toISOString());
        }
        if (Array.isArray(this.xData)) {
            data["xData"] = [];
            for (let item of this.xData)
                data["xData"].push(item);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDASChart {
    yData: Date[];
    xData: number[];
    data: Point[];
}

export class AlarmDASChart extends DASChart implements IAlarmDASChart {
    id!: string;
    minDate?: Date | undefined;
    areaOfInterest!: AreaOfInterest;

    constructor(data?: IAlarmDASChart) {
        super(data);
        if (!data) {
            this.areaOfInterest = new AreaOfInterest();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.minDate = _data["minDate"] ? new Date(_data["minDate"].toString()) : <any>undefined;
            this.areaOfInterest = _data["areaOfInterest"] ? AreaOfInterest.fromJS(_data["areaOfInterest"]) : new AreaOfInterest();
        }
    }

    static override fromJS(data: any): AlarmDASChart {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmDASChart();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["minDate"] = this.minDate ? this.minDate.toISOString() : <any>undefined;
        data["areaOfInterest"] = this.areaOfInterest ? this.areaOfInterest.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAlarmDASChart extends IDASChart {
    id: string;
    minDate?: Date | undefined;
    areaOfInterest: AreaOfInterest;
}

export class Point implements IPoint {
    x!: number;
    y!: number;
    value!: number;

    constructor(data?: IPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Point {
        data = typeof data === 'object' ? data : {};
        let result = new Point();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        data["value"] = this.value;
        return data;
    }
}

export interface IPoint {
    x: number;
    y: number;
    value: number;
}

export class DoBChart implements IDoBChart {
    doB!: number[][];
    cable!: number[][];
    seabed!: number[][];

    constructor(data?: IDoBChart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.doB = [];
            this.cable = [];
            this.seabed = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["doB"])) {
                this.doB = [] as any;
                for (let item of _data["doB"])
                    this.doB!.push(item);
            }
            if (Array.isArray(_data["cable"])) {
                this.cable = [] as any;
                for (let item of _data["cable"])
                    this.cable!.push(item);
            }
            if (Array.isArray(_data["seabed"])) {
                this.seabed = [] as any;
                for (let item of _data["seabed"])
                    this.seabed!.push(item);
            }
        }
    }

    static fromJS(data: any): DoBChart {
        data = typeof data === 'object' ? data : {};
        let result = new DoBChart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.doB)) {
            data["doB"] = [];
            for (let item of this.doB)
                data["doB"].push(item);
        }
        if (Array.isArray(this.cable)) {
            data["cable"] = [];
            for (let item of this.cable)
                data["cable"].push(item);
        }
        if (Array.isArray(this.seabed)) {
            data["seabed"] = [];
            for (let item of this.seabed)
                data["seabed"].push(item);
        }
        return data;
    }
}

export interface IDoBChart {
    doB: number[][];
    cable: number[][];
    seabed: number[][];
}

export class AlarmDoBChart extends DoBChart implements IAlarmDoBChart {
    id!: string;
    areaOfInterest!: AreaOfInterest;

    constructor(data?: IAlarmDoBChart) {
        super(data);
        if (!data) {
            this.areaOfInterest = new AreaOfInterest();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.areaOfInterest = _data["areaOfInterest"] ? AreaOfInterest.fromJS(_data["areaOfInterest"]) : new AreaOfInterest();
        }
    }

    static override fromJS(data: any): AlarmDoBChart {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmDoBChart();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["areaOfInterest"] = this.areaOfInterest ? this.areaOfInterest.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAlarmDoBChart extends IDoBChart {
    id: string;
    areaOfInterest: AreaOfInterest;
}

export class MapCableDataPoint implements IMapCableDataPoint {
    coordinate!: Coordinate;
    index!: number;
    kp!: number;
    doB?: number | undefined;
    dts?: number | undefined;
    das?: number | undefined;
    alarms!: Alarm[];
    hasAlarms!: boolean;

    constructor(data?: IMapCableDataPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.coordinate = new Coordinate();
            this.alarms = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coordinate = _data["coordinate"] ? Coordinate.fromJS(_data["coordinate"]) : new Coordinate();
            this.index = _data["index"];
            this.kp = _data["kp"];
            this.doB = _data["doB"];
            this.dts = _data["dts"];
            this.das = _data["das"];
            if (Array.isArray(_data["alarms"])) {
                this.alarms = [] as any;
                for (let item of _data["alarms"])
                    this.alarms!.push(Alarm.fromJS(item));
            }
            this.hasAlarms = _data["hasAlarms"];
        }
    }

    static fromJS(data: any): MapCableDataPoint {
        data = typeof data === 'object' ? data : {};
        let result = new MapCableDataPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coordinate"] = this.coordinate ? this.coordinate.toJSON() : <any>undefined;
        data["index"] = this.index;
        data["kp"] = this.kp;
        data["doB"] = this.doB;
        data["dts"] = this.dts;
        data["das"] = this.das;
        if (Array.isArray(this.alarms)) {
            data["alarms"] = [];
            for (let item of this.alarms)
                data["alarms"].push(item.toJSON());
        }
        data["hasAlarms"] = this.hasAlarms;
        return data;
    }
}

export interface IMapCableDataPoint {
    coordinate: Coordinate;
    index: number;
    kp: number;
    doB?: number | undefined;
    dts?: number | undefined;
    das?: number | undefined;
    alarms: Alarm[];
    hasAlarms: boolean;
}

export class CableInfo implements ICableInfo {
    minKp!: number;
    maxKp!: number;
    exists!: boolean;
    resolution!: number;
    fileName?: string | undefined;

    constructor(data?: ICableInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minKp = _data["minKp"];
            this.maxKp = _data["maxKp"];
            this.exists = _data["exists"];
            this.resolution = _data["resolution"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): CableInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CableInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minKp"] = this.minKp;
        data["maxKp"] = this.maxKp;
        data["exists"] = this.exists;
        data["resolution"] = this.resolution;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface ICableInfo {
    minKp: number;
    maxKp: number;
    exists: boolean;
    resolution: number;
    fileName?: string | undefined;
}

export class AuthConfiguration implements IAuthConfiguration {
    ignoreAuth!: boolean;
    authority!: string;
    validIssuer!: string;
    appId!: string;
    audience!: string;
    tenantId!: string;
    tenantName!: string;

    constructor(data?: IAuthConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ignoreAuth = _data["ignoreAuth"];
            this.authority = _data["authority"];
            this.validIssuer = _data["validIssuer"];
            this.appId = _data["appId"];
            this.audience = _data["audience"];
            this.tenantId = _data["tenantId"];
            this.tenantName = _data["tenantName"];
        }
    }

    static fromJS(data: any): AuthConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new AuthConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ignoreAuth"] = this.ignoreAuth;
        data["authority"] = this.authority;
        data["validIssuer"] = this.validIssuer;
        data["appId"] = this.appId;
        data["audience"] = this.audience;
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        return data;
    }
}

export interface IAuthConfiguration {
    ignoreAuth: boolean;
    authority: string;
    validIssuer: string;
    appId: string;
    audience: string;
    tenantId: string;
    tenantName: string;
}

export class ChartFilter implements IChartFilter {
    timestamp?: Date | undefined;
    minKp?: number | undefined;
    maxKp?: number | undefined;
    sampling!: number;

    constructor(data?: IChartFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.minKp = _data["minKp"];
            this.maxKp = _data["maxKp"];
            this.sampling = _data["sampling"];
        }
    }

    static fromJS(data: any): ChartFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ChartFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["minKp"] = this.minKp;
        data["maxKp"] = this.maxKp;
        data["sampling"] = this.sampling;
        return data;
    }
}

export interface IChartFilter {
    timestamp?: Date | undefined;
    minKp?: number | undefined;
    maxKp?: number | undefined;
    sampling: number;
}

export class DasValue implements IDasValue {
    timestamp!: Date;
    value!: number;
    kp!: number;
    projectId!: string;

    constructor(data?: IDasValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.value = _data["value"];
            this.kp = _data["kp"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): DasValue {
        data = typeof data === 'object' ? data : {};
        let result = new DasValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["value"] = this.value;
        data["kp"] = this.kp;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IDasValue {
    timestamp: Date;
    value: number;
    kp: number;
    projectId: string;
}

export class DoBValue implements IDoBValue {
    kp!: number;
    doB!: number;
    seabed!: number;
    cable!: number;
    projectId!: string;

    constructor(data?: IDoBValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kp = _data["kp"];
            this.doB = _data["doB"];
            this.seabed = _data["seabed"];
            this.cable = _data["cable"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): DoBValue {
        data = typeof data === 'object' ? data : {};
        let result = new DoBValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kp"] = this.kp;
        data["doB"] = this.doB;
        data["seabed"] = this.seabed;
        data["cable"] = this.cable;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IDoBValue {
    kp: number;
    doB: number;
    seabed: number;
    cable: number;
    projectId: string;
}

export class File implements IFile {
    id!: string;
    name!: string;
    fileOwner?: UserInfo | undefined;
    parentFolderId!: string;
    fileSize!: number;
    timestamp!: Date;
    subcategory?: string | undefined;
    relationType!: RelationType[];
    relatedItem?: any | undefined;

    constructor(data?: IFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.relationType = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fileOwner = _data["fileOwner"] ? UserInfo.fromJS(_data["fileOwner"]) : <any>undefined;
            this.parentFolderId = _data["parentFolderId"];
            this.fileSize = _data["fileSize"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.subcategory = _data["subcategory"];
            if (Array.isArray(_data["relationType"])) {
                this.relationType = [] as any;
                for (let item of _data["relationType"])
                    this.relationType!.push(item);
            }
            this.relatedItem = _data["relatedItem"];
        }
    }

    static fromJS(data: any): File {
        data = typeof data === 'object' ? data : {};
        let result = new File();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fileOwner"] = this.fileOwner ? this.fileOwner.toJSON() : <any>undefined;
        data["parentFolderId"] = this.parentFolderId;
        data["fileSize"] = this.fileSize;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["subcategory"] = this.subcategory;
        if (Array.isArray(this.relationType)) {
            data["relationType"] = [];
            for (let item of this.relationType)
                data["relationType"].push(item);
        }
        data["relatedItem"] = this.relatedItem;
        return data;
    }
}

export interface IFile {
    id: string;
    name: string;
    fileOwner?: UserInfo | undefined;
    parentFolderId: string;
    fileSize: number;
    timestamp: Date;
    subcategory?: string | undefined;
    relationType: RelationType[];
    relatedItem?: any | undefined;
}

export enum RelationType {
    RTTR = "RTTR",
    AISMonitoringReport = "AISMonitoringReport",
    MarineSurveyData = "MarineSurveyData",
    SpareParts = "SpareParts",
    CableShape = "CableShape",
}

export class FilesRequest implements IFilesRequest {
    search?: string | undefined;
    folder?: string | undefined;
    subCategory?: string | undefined;
    relationType?: RelationType | undefined;
    relatedProjects!: string[];
    orgLocation?: string | undefined;

    constructor(data?: IFilesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.relatedProjects = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["search"];
            this.folder = _data["folder"];
            this.subCategory = _data["subCategory"];
            this.relationType = _data["relationType"];
            if (Array.isArray(_data["relatedProjects"])) {
                this.relatedProjects = [] as any;
                for (let item of _data["relatedProjects"])
                    this.relatedProjects!.push(item);
            }
            this.orgLocation = _data["orgLocation"];
        }
    }

    static fromJS(data: any): FilesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FilesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["search"] = this.search;
        data["folder"] = this.folder;
        data["subCategory"] = this.subCategory;
        data["relationType"] = this.relationType;
        if (Array.isArray(this.relatedProjects)) {
            data["relatedProjects"] = [];
            for (let item of this.relatedProjects)
                data["relatedProjects"].push(item);
        }
        data["orgLocation"] = this.orgLocation;
        return data;
    }
}

export interface IFilesRequest {
    search?: string | undefined;
    folder?: string | undefined;
    subCategory?: string | undefined;
    relationType?: RelationType | undefined;
    relatedProjects: string[];
    orgLocation?: string | undefined;
}

export class Folder implements IFolder {
    id?: string | undefined;
    name?: string | undefined;
    numberOfFiles!: number;
    type!: FolderType;
    projectId?: string | undefined;
    order!: number;

    constructor(data?: IFolder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.numberOfFiles = _data["numberOfFiles"];
            this.type = _data["type"];
            this.projectId = _data["projectId"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): Folder {
        data = typeof data === 'object' ? data : {};
        let result = new Folder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["numberOfFiles"] = this.numberOfFiles;
        data["type"] = this.type;
        data["projectId"] = this.projectId;
        data["order"] = this.order;
        return data;
    }
}

export interface IFolder {
    id?: string | undefined;
    name?: string | undefined;
    numberOfFiles: number;
    type: FolderType;
    projectId?: string | undefined;
    order: number;
}

export enum FolderType {
    Shared = "Shared",
    Custom = "Custom",
}

export class ProjectFolder implements IProjectFolder {
    project?: Project | undefined;
    folders!: Folder[];

    constructor(data?: IProjectFolder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.folders = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
            if (Array.isArray(_data["folders"])) {
                this.folders = [] as any;
                for (let item of _data["folders"])
                    this.folders!.push(Folder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectFolder {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectFolder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        if (Array.isArray(this.folders)) {
            data["folders"] = [];
            for (let item of this.folders)
                data["folders"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectFolder {
    project?: Project | undefined;
    folders: Folder[];
}

export class Project implements IProject {
    id!: string;
    name!: string;
    organizationId!: string;
    country?: string | undefined;
    cableName?: string | undefined;
    voltage?: string | undefined;
    acdc?: string | undefined;
    commissioningDate?: Date | undefined;
    dtsDeviceId?: string | undefined;
    dasDeviceId?: string | undefined;
    aisProjectId?: string | undefined;
    created?: Date | undefined;
    electricalPerformanceDisabled!: boolean;
    mechanicalPhysicalDisabled!: boolean;
    marineSurveyDataDisabled!: boolean;
    sparePartsDisabled!: boolean;
    documentationDisabled!: boolean;
    alarmLogsDisabled!: boolean;
    vesselsHomePageDisabled!: boolean;
    doBHomePageDisabled!: boolean;
    dasHomePageDisabled!: boolean;
    dtsHomePageDisabled!: boolean;

    constructor(data?: IProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.organizationId = _data["organizationId"];
            this.country = _data["country"];
            this.cableName = _data["cableName"];
            this.voltage = _data["voltage"];
            this.acdc = _data["acdc"];
            this.commissioningDate = _data["commissioningDate"] ? new Date(_data["commissioningDate"].toString()) : <any>undefined;
            this.dtsDeviceId = _data["dtsDeviceId"];
            this.dasDeviceId = _data["dasDeviceId"];
            this.aisProjectId = _data["aisProjectId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.electricalPerformanceDisabled = _data["electricalPerformanceDisabled"];
            this.mechanicalPhysicalDisabled = _data["mechanicalPhysicalDisabled"];
            this.marineSurveyDataDisabled = _data["marineSurveyDataDisabled"];
            this.sparePartsDisabled = _data["sparePartsDisabled"];
            this.documentationDisabled = _data["documentationDisabled"];
            this.alarmLogsDisabled = _data["alarmLogsDisabled"];
            this.vesselsHomePageDisabled = _data["vesselsHomePageDisabled"];
            this.doBHomePageDisabled = _data["doBHomePageDisabled"];
            this.dasHomePageDisabled = _data["dasHomePageDisabled"];
            this.dtsHomePageDisabled = _data["dtsHomePageDisabled"];
        }
    }

    static fromJS(data: any): Project {
        data = typeof data === 'object' ? data : {};
        let result = new Project();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["organizationId"] = this.organizationId;
        data["country"] = this.country;
        data["cableName"] = this.cableName;
        data["voltage"] = this.voltage;
        data["acdc"] = this.acdc;
        data["commissioningDate"] = this.commissioningDate ? this.commissioningDate.toISOString() : <any>undefined;
        data["dtsDeviceId"] = this.dtsDeviceId;
        data["dasDeviceId"] = this.dasDeviceId;
        data["aisProjectId"] = this.aisProjectId;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["electricalPerformanceDisabled"] = this.electricalPerformanceDisabled;
        data["mechanicalPhysicalDisabled"] = this.mechanicalPhysicalDisabled;
        data["marineSurveyDataDisabled"] = this.marineSurveyDataDisabled;
        data["sparePartsDisabled"] = this.sparePartsDisabled;
        data["documentationDisabled"] = this.documentationDisabled;
        data["alarmLogsDisabled"] = this.alarmLogsDisabled;
        data["vesselsHomePageDisabled"] = this.vesselsHomePageDisabled;
        data["doBHomePageDisabled"] = this.doBHomePageDisabled;
        data["dasHomePageDisabled"] = this.dasHomePageDisabled;
        data["dtsHomePageDisabled"] = this.dtsHomePageDisabled;
        return data;
    }
}

export interface IProject {
    id: string;
    name: string;
    organizationId: string;
    country?: string | undefined;
    cableName?: string | undefined;
    voltage?: string | undefined;
    acdc?: string | undefined;
    commissioningDate?: Date | undefined;
    dtsDeviceId?: string | undefined;
    dasDeviceId?: string | undefined;
    aisProjectId?: string | undefined;
    created?: Date | undefined;
    electricalPerformanceDisabled: boolean;
    mechanicalPhysicalDisabled: boolean;
    marineSurveyDataDisabled: boolean;
    sparePartsDisabled: boolean;
    documentationDisabled: boolean;
    alarmLogsDisabled: boolean;
    vesselsHomePageDisabled: boolean;
    doBHomePageDisabled: boolean;
    dasHomePageDisabled: boolean;
    dtsHomePageDisabled: boolean;
}

export class DtsValue implements IDtsValue {
    timestamp!: Date;
    value!: number;
    kp!: number;
    type!: DTSType;
    projectId!: string;

    constructor(data?: IDtsValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.value = _data["value"];
            this.kp = _data["kp"];
            this.type = _data["type"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): DtsValue {
        data = typeof data === 'object' ? data : {};
        let result = new DtsValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["value"] = this.value;
        data["kp"] = this.kp;
        data["type"] = this.type;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IDtsValue {
    timestamp: Date;
    value: number;
    kp: number;
    type: DTSType;
    projectId: string;
}

export class DTSChartFilter extends ChartFilter implements IDTSChartFilter {
    types?: DTSType[] | undefined;

    constructor(data?: IDTSChartFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
        }
    }

    static override fromJS(data: any): DTSChartFilter {
        data = typeof data === 'object' ? data : {};
        let result = new DTSChartFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDTSChartFilter extends IChartFilter {
    types?: DTSType[] | undefined;
}

export class OverviewModel implements IOverviewModel {
    cable!: MapCableDataPoint[];
    vessels!: CableVessel[];
    alarms!: Alarm[];
    alarmCount!: number;
    cableLength!: number;
    midPoint!: Coordinate;

    constructor(data?: IOverviewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.cable = [];
            this.vessels = [];
            this.alarms = [];
            this.midPoint = new Coordinate();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cable"])) {
                this.cable = [] as any;
                for (let item of _data["cable"])
                    this.cable!.push(MapCableDataPoint.fromJS(item));
            }
            if (Array.isArray(_data["vessels"])) {
                this.vessels = [] as any;
                for (let item of _data["vessels"])
                    this.vessels!.push(CableVessel.fromJS(item));
            }
            if (Array.isArray(_data["alarms"])) {
                this.alarms = [] as any;
                for (let item of _data["alarms"])
                    this.alarms!.push(Alarm.fromJS(item));
            }
            this.alarmCount = _data["alarmCount"];
            this.cableLength = _data["cableLength"];
            this.midPoint = _data["midPoint"] ? Coordinate.fromJS(_data["midPoint"]) : new Coordinate();
        }
    }

    static fromJS(data: any): OverviewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OverviewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cable)) {
            data["cable"] = [];
            for (let item of this.cable)
                data["cable"].push(item.toJSON());
        }
        if (Array.isArray(this.vessels)) {
            data["vessels"] = [];
            for (let item of this.vessels)
                data["vessels"].push(item.toJSON());
        }
        if (Array.isArray(this.alarms)) {
            data["alarms"] = [];
            for (let item of this.alarms)
                data["alarms"].push(item.toJSON());
        }
        data["alarmCount"] = this.alarmCount;
        data["cableLength"] = this.cableLength;
        data["midPoint"] = this.midPoint ? this.midPoint.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOverviewModel {
    cable: MapCableDataPoint[];
    vessels: CableVessel[];
    alarms: Alarm[];
    alarmCount: number;
    cableLength: number;
    midPoint: Coordinate;
}

export class Location implements ILocation {
    id?: string | undefined;
    name?: string | undefined;
    streetName?: string | undefined;
    streetNumber?: string | undefined;
    addressLine2?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    organisationId?: string | undefined;

    constructor(data?: ILocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.streetName = _data["streetName"];
            this.streetNumber = _data["streetNumber"];
            this.addressLine2 = _data["addressLine2"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.organisationId = _data["organisationId"];
        }
    }

    static fromJS(data: any): Location {
        data = typeof data === 'object' ? data : {};
        let result = new Location();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["streetName"] = this.streetName;
        data["streetNumber"] = this.streetNumber;
        data["addressLine2"] = this.addressLine2;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["country"] = this.country;
        data["organisationId"] = this.organisationId;
        return data;
    }
}

export interface ILocation {
    id?: string | undefined;
    name?: string | undefined;
    streetName?: string | undefined;
    streetNumber?: string | undefined;
    addressLine2?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    organisationId?: string | undefined;
}

export class OrgLocations implements IOrgLocations {
    organization!: AppOrganization;
    locations!: Location[];

    constructor(data?: IOrgLocations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.organization = new AppOrganization();
            this.locations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organization = _data["organization"] ? AppOrganization.fromJS(_data["organization"]) : new AppOrganization();
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(Location.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrgLocations {
        data = typeof data === 'object' ? data : {};
        let result = new OrgLocations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organization"] = this.organization ? this.organization.toJSON() : <any>undefined;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrgLocations {
    organization: AppOrganization;
    locations: Location[];
}

export class AppOrganization implements IAppOrganization {
    id!: string;
    name!: string;
    adminEmail?: string | undefined;
    adminName?: string | undefined;

    constructor(data?: IAppOrganization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.adminEmail = _data["adminEmail"];
            this.adminName = _data["adminName"];
        }
    }

    static fromJS(data: any): AppOrganization {
        data = typeof data === 'object' ? data : {};
        let result = new AppOrganization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["adminEmail"] = this.adminEmail;
        data["adminName"] = this.adminName;
        return data;
    }
}

export interface IAppOrganization {
    id: string;
    name: string;
    adminEmail?: string | undefined;
    adminName?: string | undefined;
}

export class NewAppOrganization implements INewAppOrganization {
    name!: string;

    constructor(data?: INewAppOrganization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): NewAppOrganization {
        data = typeof data === 'object' ? data : {};
        let result = new NewAppOrganization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface INewAppOrganization {
    name: string;
}

export class AppOrganizationWithUsers extends AppOrganization implements IAppOrganizationWithUsers {
    users!: AppUser[];

    constructor(data?: IAppOrganizationWithUsers) {
        super(data);
        if (!data) {
            this.users = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(AppUser.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AppOrganizationWithUsers {
        data = typeof data === 'object' ? data : {};
        let result = new AppOrganizationWithUsers();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAppOrganizationWithUsers extends IAppOrganization {
    users: AppUser[];
}

export class AppUser implements IAppUser {
    id!: string;
    email!: string;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    roleValue?: string | undefined;
    organizationId?: string | undefined;
    projectIds!: string[];

    constructor(data?: IAppUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.projectIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.roleValue = _data["roleValue"];
            this.organizationId = _data["organizationId"];
            if (Array.isArray(_data["projectIds"])) {
                this.projectIds = [] as any;
                for (let item of _data["projectIds"])
                    this.projectIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AppUser {
        data = typeof data === 'object' ? data : {};
        let result = new AppUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["roleValue"] = this.roleValue;
        data["organizationId"] = this.organizationId;
        if (Array.isArray(this.projectIds)) {
            data["projectIds"] = [];
            for (let item of this.projectIds)
                data["projectIds"].push(item);
        }
        return data;
    }
}

export interface IAppUser {
    id: string;
    email: string;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    roleValue?: string | undefined;
    organizationId?: string | undefined;
    projectIds: string[];
}

export class NewProject implements INewProject {
    id?: string | undefined;
    name?: string | undefined;
    organizationId?: string | undefined;
    country?: string | undefined;
    created?: Date | undefined;

    constructor(data?: INewProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.organizationId = _data["organizationId"];
            this.country = _data["country"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NewProject {
        data = typeof data === 'object' ? data : {};
        let result = new NewProject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["organizationId"] = this.organizationId;
        data["country"] = this.country;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface INewProject {
    id?: string | undefined;
    name?: string | undefined;
    organizationId?: string | undefined;
    country?: string | undefined;
    created?: Date | undefined;
}

export class ProcessItem implements IProcessItem {
    id?: string | undefined;
    name!: string;
    projectId!: string;
    timestamp!: Date;
    processType!: ProcessDataType;
    processed!: boolean;

    constructor(data?: IProcessItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.processType = _data["processType"];
            this.processed = _data["processed"];
        }
    }

    static fromJS(data: any): ProcessItem {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["processType"] = this.processType;
        data["processed"] = this.processed;
        return data;
    }
}

export interface IProcessItem {
    id?: string | undefined;
    name: string;
    projectId: string;
    timestamp: Date;
    processType: ProcessDataType;
    processed: boolean;
}

export enum ProcessDataType {
    AISVessels = "AISVessels",
    AISEvents = "AISEvents",
    DASAlarms = "DASAlarms",
    CableShape = "CableShape",
    DoB = "DoB",
    DTS = "DTS",
    DAS = "DAS",
    DTSAlarms = "DTSAlarms",
}

export class RttrValue implements IRttrValue {
    projectId!: string;
    powerCableCircuit!: RttrPowerCableCircuit;
    emergencyRating!: RttrEmergencyRating;

    constructor(data?: IRttrValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.powerCableCircuit = new RttrPowerCableCircuit();
            this.emergencyRating = new RttrEmergencyRating();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.powerCableCircuit = _data["powerCableCircuit"] ? RttrPowerCableCircuit.fromJS(_data["powerCableCircuit"]) : new RttrPowerCableCircuit();
            this.emergencyRating = _data["emergencyRating"] ? RttrEmergencyRating.fromJS(_data["emergencyRating"]) : new RttrEmergencyRating();
        }
    }

    static fromJS(data: any): RttrValue {
        data = typeof data === 'object' ? data : {};
        let result = new RttrValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["powerCableCircuit"] = this.powerCableCircuit ? this.powerCableCircuit.toJSON() : <any>undefined;
        data["emergencyRating"] = this.emergencyRating ? this.emergencyRating.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRttrValue {
    projectId: string;
    powerCableCircuit: RttrPowerCableCircuit;
    emergencyRating: RttrEmergencyRating;
}

export class RttrPowerCableCircuit implements IRttrPowerCableCircuit {
    sensorHotspotTemp!: number;
    conductorTemp!: number;
    currentLoad!: number;
    maximumLoad!: number;
    loadRatio!: number;
    loadFactor!: number;
    lastRatingTime!: Date;

    constructor(data?: IRttrPowerCableCircuit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sensorHotspotTemp = _data["sensorHotspotTemp"];
            this.conductorTemp = _data["conductorTemp"];
            this.currentLoad = _data["currentLoad"];
            this.maximumLoad = _data["maximumLoad"];
            this.loadRatio = _data["loadRatio"];
            this.loadFactor = _data["loadFactor"];
            this.lastRatingTime = _data["lastRatingTime"] ? new Date(_data["lastRatingTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RttrPowerCableCircuit {
        data = typeof data === 'object' ? data : {};
        let result = new RttrPowerCableCircuit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sensorHotspotTemp"] = this.sensorHotspotTemp;
        data["conductorTemp"] = this.conductorTemp;
        data["currentLoad"] = this.currentLoad;
        data["maximumLoad"] = this.maximumLoad;
        data["loadRatio"] = this.loadRatio;
        data["loadFactor"] = this.loadFactor;
        data["lastRatingTime"] = this.lastRatingTime ? this.lastRatingTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRttrPowerCableCircuit {
    sensorHotspotTemp: number;
    conductorTemp: number;
    currentLoad: number;
    maximumLoad: number;
    loadRatio: number;
    loadFactor: number;
    lastRatingTime: Date;
}

export class RttrEmergencyRating implements IRttrEmergencyRating {
    twentyFourHourRatingAt90DegC!: number;
    fortyEightHourRatingAt90DegC!: number;
    ampTempRating!: RttrRow;
    ampTimeRating!: RttrRow;

    constructor(data?: IRttrEmergencyRating) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ampTempRating = new RttrRow();
            this.ampTimeRating = new RttrRow();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.twentyFourHourRatingAt90DegC = _data["twentyFourHourRatingAt90DegC"];
            this.fortyEightHourRatingAt90DegC = _data["fortyEightHourRatingAt90DegC"];
            this.ampTempRating = _data["ampTempRating"] ? RttrRow.fromJS(_data["ampTempRating"]) : new RttrRow();
            this.ampTimeRating = _data["ampTimeRating"] ? RttrRow.fromJS(_data["ampTimeRating"]) : new RttrRow();
        }
    }

    static fromJS(data: any): RttrEmergencyRating {
        data = typeof data === 'object' ? data : {};
        let result = new RttrEmergencyRating();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["twentyFourHourRatingAt90DegC"] = this.twentyFourHourRatingAt90DegC;
        data["fortyEightHourRatingAt90DegC"] = this.fortyEightHourRatingAt90DegC;
        data["ampTempRating"] = this.ampTempRating ? this.ampTempRating.toJSON() : <any>undefined;
        data["ampTimeRating"] = this.ampTimeRating ? this.ampTimeRating.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRttrEmergencyRating {
    twentyFourHourRatingAt90DegC: number;
    fortyEightHourRatingAt90DegC: number;
    ampTempRating: RttrRow;
    ampTimeRating: RttrRow;
}

export class RttrRow implements IRttrRow {
    displayName!: string;
    value!: number;

    constructor(data?: IRttrRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): RttrRow {
        data = typeof data === 'object' ? data : {};
        let result = new RttrRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["value"] = this.value;
        return data;
    }
}

export interface IRttrRow {
    displayName: string;
    value: number;
}

export class SparePartLocation implements ISparePartLocation {
    id!: string;
    name!: string;
    address!: string;

    constructor(data?: ISparePartLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): SparePartLocation {
        data = typeof data === 'object' ? data : {};
        let result = new SparePartLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address;
        return data;
    }
}

export interface ISparePartLocation {
    id: string;
    name: string;
    address: string;
}

export class SparePartRequest implements ISparePartRequest {
    location?: string | undefined;
    expiresOnDate?: Date | undefined;

    constructor(data?: ISparePartRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"];
            this.expiresOnDate = _data["expiresOnDate"] ? new Date(_data["expiresOnDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SparePartRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SparePartRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location;
        data["expiresOnDate"] = this.expiresOnDate ? this.expiresOnDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISparePartRequest {
    location?: string | undefined;
    expiresOnDate?: Date | undefined;
}

export class SurveyInfo implements ISurveyInfo {
    id!: string;
    displayName?: string | undefined;

    constructor(data?: ISurveyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SurveyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISurveyInfo {
    id: string;
    displayName?: string | undefined;
}

export class SurveyDoBChart implements ISurveyDoBChart {
    seriesCable!: DataSeries[];
    seriesDoB!: DataSeries[];

    constructor(data?: ISurveyDoBChart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.seriesCable = [];
            this.seriesDoB = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["seriesCable"])) {
                this.seriesCable = [] as any;
                for (let item of _data["seriesCable"])
                    this.seriesCable!.push(DataSeries.fromJS(item));
            }
            if (Array.isArray(_data["seriesDoB"])) {
                this.seriesDoB = [] as any;
                for (let item of _data["seriesDoB"])
                    this.seriesDoB!.push(DataSeries.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyDoBChart {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyDoBChart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.seriesCable)) {
            data["seriesCable"] = [];
            for (let item of this.seriesCable)
                data["seriesCable"].push(item.toJSON());
        }
        if (Array.isArray(this.seriesDoB)) {
            data["seriesDoB"] = [];
            for (let item of this.seriesDoB)
                data["seriesDoB"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISurveyDoBChart {
    seriesCable: DataSeries[];
    seriesDoB: DataSeries[];
}

export class CurrentUser implements ICurrentUser {
    email?: string | undefined;
    name?: string | undefined;
    userId?: string | undefined;
    organizationId?: string | undefined;
    phoneNumber?: string | undefined;
    roles!: string[];
    projectIds!: string[];

    constructor(data?: ICurrentUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.roles = [];
            this.projectIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.name = _data["name"];
            this.userId = _data["userId"];
            this.organizationId = _data["organizationId"];
            this.phoneNumber = _data["phoneNumber"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["projectIds"])) {
                this.projectIds = [] as any;
                for (let item of _data["projectIds"])
                    this.projectIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CurrentUser {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["name"] = this.name;
        data["userId"] = this.userId;
        data["organizationId"] = this.organizationId;
        data["phoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.projectIds)) {
            data["projectIds"] = [];
            for (let item of this.projectIds)
                data["projectIds"].push(item);
        }
        return data;
    }
}

export interface ICurrentUser {
    email?: string | undefined;
    name?: string | undefined;
    userId?: string | undefined;
    organizationId?: string | undefined;
    phoneNumber?: string | undefined;
    roles: string[];
    projectIds: string[];
}

export class AppUserAccess implements IAppUserAccess {
    userId?: string | undefined;
    email!: string;
    organizationId!: string;
    roleValue!: string;
    projectIds!: string[];

    constructor(data?: IAppUserAccess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.projectIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.organizationId = _data["organizationId"];
            this.roleValue = _data["roleValue"];
            if (Array.isArray(_data["projectIds"])) {
                this.projectIds = [] as any;
                for (let item of _data["projectIds"])
                    this.projectIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AppUserAccess {
        data = typeof data === 'object' ? data : {};
        let result = new AppUserAccess();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["organizationId"] = this.organizationId;
        data["roleValue"] = this.roleValue;
        if (Array.isArray(this.projectIds)) {
            data["projectIds"] = [];
            for (let item of this.projectIds)
                data["projectIds"].push(item);
        }
        return data;
    }
}

export interface IAppUserAccess {
    userId?: string | undefined;
    email: string;
    organizationId: string;
    roleValue: string;
    projectIds: string[];
}

export class VesselInfo implements IVesselInfo {
    vesselName?: string | undefined;
    vesselTypeName?: string | undefined;
    mmsi!: number;
    speedOverGround?: number | undefined;
    courseOverGround?: number | undefined;
    vesselType!: VesselTypes;
    latitude!: number;
    longitude!: number;
    radioCallSign?: string | undefined;
    destination?: string | undefined;

    constructor(data?: IVesselInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vesselName = _data["vesselName"];
            this.vesselTypeName = _data["vesselTypeName"];
            this.mmsi = _data["mmsi"];
            this.speedOverGround = _data["speedOverGround"];
            this.courseOverGround = _data["courseOverGround"];
            this.vesselType = _data["vesselType"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.radioCallSign = _data["radioCallSign"];
            this.destination = _data["destination"];
        }
    }

    static fromJS(data: any): VesselInfo {
        data = typeof data === 'object' ? data : {};
        let result = new VesselInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vesselName"] = this.vesselName;
        data["vesselTypeName"] = this.vesselTypeName;
        data["mmsi"] = this.mmsi;
        data["speedOverGround"] = this.speedOverGround;
        data["courseOverGround"] = this.courseOverGround;
        data["vesselType"] = this.vesselType;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["radioCallSign"] = this.radioCallSign;
        data["destination"] = this.destination;
        return data;
    }
}

export interface IVesselInfo {
    vesselName?: string | undefined;
    vesselTypeName?: string | undefined;
    mmsi: number;
    speedOverGround?: number | undefined;
    courseOverGround?: number | undefined;
    vesselType: VesselTypes;
    latitude: number;
    longitude: number;
    radioCallSign?: string | undefined;
    destination?: string | undefined;
}

export enum VesselTypes {
    Fishing = "Fishing",
    Cargo = "Cargo",
    Tanker = "Tanker",
    Underwater = "Underwater",
    Diving = "Diving",
    Passenger = "Passenger",
    Unknown = "Unknown",
    Other = "Other",
}

export class VesselInfoRequest implements IVesselInfoRequest {
    mmsi!: number;
    timestamp!: Date;

    constructor(data?: IVesselInfoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mmsi = _data["mmsi"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): VesselInfoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VesselInfoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mmsi"] = this.mmsi;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface IVesselInfoRequest {
    mmsi: number;
    timestamp: Date;
}

export class ApiGroupNames implements IApiGroupNames {
    apiTitle?: string | undefined;
    groupNames!: string[];
    version?: string | undefined;

    constructor(data?: IApiGroupNames) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.groupNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiTitle = _data["apiTitle"];
            if (Array.isArray(_data["groupNames"])) {
                this.groupNames = [] as any;
                for (let item of _data["groupNames"])
                    this.groupNames!.push(item);
            }
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): ApiGroupNames {
        data = typeof data === 'object' ? data : {};
        let result = new ApiGroupNames();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiTitle"] = this.apiTitle;
        if (Array.isArray(this.groupNames)) {
            data["groupNames"] = [];
            for (let item of this.groupNames)
                data["groupNames"].push(item);
        }
        data["version"] = this.version;
        return data;
    }
}

export interface IApiGroupNames {
    apiTitle?: string | undefined;
    groupNames: string[];
    version?: string | undefined;
}

export class UserAuthenticationInfo implements IUserAuthenticationInfo {
    email?: string | undefined;
    name?: string | undefined;
    userId?: string | undefined;
    tenantName?: string | undefined;
    tenantId?: string | undefined;
    authenticationScheme?: string | undefined;
    roles!: string[];

    constructor(data?: IUserAuthenticationInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.roles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.name = _data["name"];
            this.userId = _data["userId"];
            this.tenantName = _data["tenantName"];
            this.tenantId = _data["tenantId"];
            this.authenticationScheme = _data["authenticationScheme"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): UserAuthenticationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserAuthenticationInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["name"] = this.name;
        data["userId"] = this.userId;
        data["tenantName"] = this.tenantName;
        data["tenantId"] = this.tenantId;
        data["authenticationScheme"] = this.authenticationScheme;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IUserAuthenticationInfo {
    email?: string | undefined;
    name?: string | undefined;
    userId?: string | undefined;
    tenantName?: string | undefined;
    tenantId?: string | undefined;
    authenticationScheme?: string | undefined;
    roles: string[];
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

// This file is inserted into into the generated *-backend.ts. VSCode does not know this, and removes the imports when saving it, so use another editor when modifying this file. (－‸ლ)

/* eslint-disable */

// @ts-ignore